"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * UniqKey.OrganizationApi.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopApplicationsApiFp = exports.DesktopApplicationsApiAxiosParamCreator = exports.DashboardApi = exports.DashboardApiFactory = exports.DashboardApiFp = exports.DashboardApiAxiosParamCreator = exports.CompanionApplicationApi = exports.CompanionApplicationApiFactory = exports.CompanionApplicationApiFp = exports.CompanionApplicationApiAxiosParamCreator = exports.AuditLogsApi = exports.AuditLogsApiFactory = exports.AuditLogsApiFp = exports.AuditLogsApiAxiosParamCreator = exports.ApplicationsApi = exports.ApplicationsApiFactory = exports.ApplicationsApiFp = exports.ApplicationsApiAxiosParamCreator = exports.VaultSecureNotesOrderProperty = exports.VaultOrderProperty = exports.TrustedActionType = exports.RestrictionType = exports.RestoreBulkEmployeeAccountErrorDetails = exports.QueueEvent = exports.PartnerSupportRequestsRejectFailedReason = exports.PartnerSupportRequestsApproveFailedReason = exports.PartnerSupportRequestStatusName = exports.Ownership = exports.MasterPasswordResetRequestOrderProperty = exports.GroupsByVaultIdOrderProperty = exports.GroupOrderProperty = exports.GetPartnersAccessibleToCurrentOrganizationOrderProperty = exports.GetPartnerUsersAccessibleToCurrentOrganizationOrderProperty = exports.GetPartnerSupportRequestsRequestStatus = exports.GetPartnerSupportRequestsRequestOrderProperty = exports.GetManagedByGroupsByVaultIdOrderProperty = exports.GetManagedByEmployeesByVaultIdOrderProperty = exports.EncryptionKeyType = exports.EmployeeByApplicationOrderPropertyName = exports.EmployeeAccountType = exports.EmployeeAccountStatus = exports.EmployeeAccountOrderProperty = exports.CompanionApplicationTypeName = exports.ClientType = exports.BulkRevokePartnerSupportAccessFailedReason = exports.AuthenticationType = exports.AuditLogSourceType = exports.ArchiveBulkEmployeeAccountErrorDetails = exports.ApplicationOrderPropertyName = exports.ActivityFilter = void 0;
exports.OrganizationSettingsApi = exports.OrganizationSettingsApiFactory = exports.OrganizationSettingsApiFp = exports.OrganizationSettingsApiAxiosParamCreator = exports.OrganizationKeysApi = exports.OrganizationKeysApiFactory = exports.OrganizationKeysApiFp = exports.OrganizationKeysApiAxiosParamCreator = exports.OrganizationApi = exports.OrganizationApiFactory = exports.OrganizationApiFp = exports.OrganizationApiAxiosParamCreator = exports.MigrationApi = exports.MigrationApiFactory = exports.MigrationApiFp = exports.MigrationApiAxiosParamCreator = exports.MasterPasswordResetRequestsApi = exports.MasterPasswordResetRequestsApiFactory = exports.MasterPasswordResetRequestsApiFp = exports.MasterPasswordResetRequestsApiAxiosParamCreator = exports.IpGroupRestrictionsApi = exports.IpGroupRestrictionsApiFactory = exports.IpGroupRestrictionsApiFp = exports.IpGroupRestrictionsApiAxiosParamCreator = exports.GroupsApi = exports.GroupsApiFactory = exports.GroupsApiFp = exports.GroupsApiAxiosParamCreator = exports.GroupRestrictionsApi = exports.GroupRestrictionsApiFactory = exports.GroupRestrictionsApiFp = exports.GroupRestrictionsApiAxiosParamCreator = exports.GeolocationGroupRestrictionsApi = exports.GeolocationGroupRestrictionsApiFactory = exports.GeolocationGroupRestrictionsApiFp = exports.GeolocationGroupRestrictionsApiAxiosParamCreator = exports.EmployeeAccountsToGroupsApi = exports.EmployeeAccountsToGroupsApiFactory = exports.EmployeeAccountsToGroupsApiFp = exports.EmployeeAccountsToGroupsApiAxiosParamCreator = exports.EmployeeAccountsApi = exports.EmployeeAccountsApiFactory = exports.EmployeeAccountsApiFp = exports.EmployeeAccountsApiAxiosParamCreator = exports.DomainRulesApi = exports.DomainRulesApiFactory = exports.DomainRulesApiFp = exports.DomainRulesApiAxiosParamCreator = exports.DesktopApplicationsApi = exports.DesktopApplicationsApiFactory = void 0;
exports.VaultsToGroupsApiFp = exports.VaultsToGroupsApiAxiosParamCreator = exports.VaultsToEmployeeAccountsApi = exports.VaultsToEmployeeAccountsApiFactory = exports.VaultsToEmployeeAccountsApiFp = exports.VaultsToEmployeeAccountsApiAxiosParamCreator = exports.VaultsApi = exports.VaultsApiFactory = exports.VaultsApiFp = exports.VaultsApiAxiosParamCreator = exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.TrustedActionsApi = exports.TrustedActionsApiFactory = exports.TrustedActionsApiFp = exports.TrustedActionsApiAxiosParamCreator = exports.TimeOfDayGroupRestrictionsApi = exports.TimeOfDayGroupRestrictionsApiFactory = exports.TimeOfDayGroupRestrictionsApiFp = exports.TimeOfDayGroupRestrictionsApiAxiosParamCreator = exports.SupporterApi = exports.SupporterApiFactory = exports.SupporterApiFp = exports.SupporterApiAxiosParamCreator = exports.SupportedUILanguagesApi = exports.SupportedUILanguagesApiFactory = exports.SupportedUILanguagesApiFp = exports.SupportedUILanguagesApiAxiosParamCreator = exports.SecuritySettingsApi = exports.SecuritySettingsApiFactory = exports.SecuritySettingsApiFp = exports.SecuritySettingsApiAxiosParamCreator = exports.ScimSettingsApi = exports.ScimSettingsApiFactory = exports.ScimSettingsApiFp = exports.ScimSettingsApiAxiosParamCreator = exports.QueueApi = exports.QueueApiFactory = exports.QueueApiFp = exports.QueueApiAxiosParamCreator = exports.PartnerSupportRequestsApi = exports.PartnerSupportRequestsApiFactory = exports.PartnerSupportRequestsApiFp = exports.PartnerSupportRequestsApiAxiosParamCreator = exports.PairingCodesApi = exports.PairingCodesApiFactory = exports.PairingCodesApiFp = exports.PairingCodesApiAxiosParamCreator = void 0;
exports.VerifiedDomainsApi = exports.VerifiedDomainsApiFactory = exports.VerifiedDomainsApiFp = exports.VerifiedDomainsApiAxiosParamCreator = exports.VaultsToGroupsApi = exports.VaultsToGroupsApiFactory = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.ActivityFilter = {
    Active: 'Active',
    NotActive: 'NotActive'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ApplicationOrderPropertyName = {
    Name: 'Name',
    UserCount: 'UserCount',
    SecurityScore: 'SecurityScore',
    ActivityAt: 'ActivityAt',
    VaultCount: 'VaultCount'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ArchiveBulkEmployeeAccountErrorDetails = {
    Undefined: 'Undefined',
    IsCurrentAdmin: 'IsCurrentAdmin',
    NotFound: 'NotFound',
    Unprocessed: 'Unprocessed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AuditLogSourceType = {
    User: 'User',
    Scim: 'Scim',
    System: 'System'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AuthenticationType = {
    Basic: 'Basic',
    Saml: 'SAML'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.BulkRevokePartnerSupportAccessFailedReason = {
    RecordNotFound: 'RecordNotFound',
    Other: 'Other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ClientType = {
    Extension: 'Extension',
    Desktop: 'Desktop'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CompanionApplicationTypeName = {
    BrowserExtension: 'BrowserExtension',
    WindowsLogin: 'WindowsLogin',
    WindowsDesktop: 'WindowsDesktop',
    OrganizationPortal: 'OrganizationPortal'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EmployeeAccountOrderProperty = {
    Email: 'Email',
    EmployeeAccountType: 'EmployeeAccountType',
    EmployeeAccountStatus: 'EmployeeAccountStatus',
    IsByScim: 'IsByScim',
    SecurityScore: 'SecurityScore',
    ActivityAt: 'ActivityAt',
    Name: 'Name'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EmployeeAccountStatus = {
    Unprocessed: 'Unprocessed',
    Staged: 'Staged',
    Invited: 'Invited',
    Active: 'Active',
    Archived: 'Archived',
    Migrated: 'Migrated',
    MigrationInvited: 'MigrationInvited',
    ExistingUnprocessed: 'ExistingUnprocessed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EmployeeAccountType = {
    Employee: 'Employee',
    Admin: 'Admin',
    Supporter: 'Supporter',
    KeylessAdmin: 'KeylessAdmin'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EmployeeByApplicationOrderPropertyName = {
    UserName: 'UserName',
    SecurityScore: 'SecurityScore',
    ActivityAt: 'ActivityAt'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EncryptionKeyType = {
    PairingKey: 'PairingKey',
    OrganizationKey: 'OrganizationKey'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GetManagedByEmployeesByVaultIdOrderProperty = {
    Email: 'Email',
    ActivityAt: 'ActivityAt'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GetManagedByGroupsByVaultIdOrderProperty = {
    Email: 'Email',
    ActivityAt: 'ActivityAt'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GetPartnerSupportRequestsRequestOrderProperty = {
    PartnerSupportRequestId: 'PartnerSupportRequestId',
    PartnerId: 'PartnerId',
    PartnerUserId: 'PartnerUserId',
    PartnerKeyId: 'PartnerKeyId',
    OrganizationId: 'OrganizationId',
    PartnerName: 'PartnerName',
    PartnerUserName: 'PartnerUserName',
    PartnerUserEmail: 'PartnerUserEmail',
    Status: 'Status',
    CreatedAt: 'CreatedAt',
    UpdatedAt: 'UpdatedAt',
    DeletedAt: 'DeletedAt'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GetPartnerSupportRequestsRequestStatus = {
    Pending: 'Pending',
    Approved: 'Approved',
    Rejected: 'Rejected'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GetPartnerUsersAccessibleToCurrentOrganizationOrderProperty = {
    PartnerUserEmail: 'PartnerUserEmail',
    PartnerName: 'PartnerName'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GetPartnersAccessibleToCurrentOrganizationOrderProperty = {
    PartnerName: 'PartnerName'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GroupOrderProperty = {
    Name: 'Name',
    MembersCount: 'MembersCount',
    VaultPasswordsCount: 'VaultPasswordsCount',
    IsByScim: 'IsByScim'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GroupsByVaultIdOrderProperty = {
    Name: 'Name',
    MembersCount: 'MembersCount',
    ActivityAt: 'ActivityAt'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MasterPasswordResetRequestOrderProperty = {
    Email: 'Email',
    Name: 'Name',
    CreatedAt: 'CreatedAt'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Ownership = {
    Groups: 'Groups',
    Employees: 'Employees',
    Unmanaged: 'Unmanaged'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PartnerSupportRequestStatusName = {
    Pending: 'Pending',
    Approved: 'Approved',
    Rejected: 'Rejected'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PartnerSupportRequestsApproveFailedReason = {
    RequestNotFound: 'RequestNotFound',
    Other: 'Other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PartnerSupportRequestsRejectFailedReason = {
    RequestNotFound: 'RequestNotFound',
    Other: 'Other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.QueueEvent = {
    VaultPasswordRequested: 'VaultPasswordRequested',
    ProcessNewEmployee: 'ProcessNewEmployee',
    VaultDeletionForGroupRequested: 'VaultDeletionForGroupRequested',
    VaultPasswordEditRequestedForEmployee: 'VaultPasswordEditRequestedForEmployee',
    VaultPasswordCreationForGroupRequested: 'VaultPasswordCreationForGroupRequested',
    VaultPasswordCreationForEmployeeRequested: 'VaultPasswordCreationForEmployeeRequested',
    VaultDeletionForEmployeeRequested: 'VaultDeletionForEmployeeRequested',
    PromoteAdmin: 'PromoteAdmin',
    RevokeAdmin: 'RevokeAdmin',
    ImportVault: 'ImportVault',
    VaultSharingToGroupRequested: 'VaultSharingToGroupRequested',
    VaultSharingToEmployeeAccountRequested: 'VaultSharingToEmployeeAccountRequested',
    LogoutDevice: 'LogoutDevice',
    CreateTrustedBrowserRequested: 'CreateTrustedBrowserRequested',
    ProcessInviteEmployee: 'ProcessInviteEmployee',
    ShareGroupSecretWithEmployeeAccount: 'ShareGroupSecretWithEmployeeAccount',
    MoveVaultBetweenGroups: 'MoveVaultBetweenGroups',
    MoveVaultBetweenEmployees: 'MoveVaultBetweenEmployees',
    MoveVaultFromEmployeeToGroup: 'MoveVaultFromEmployeeToGroup',
    AdminVaultPasswordCreationForGroupRequested: 'AdminVaultPasswordCreationForGroupRequested',
    AdminVaultPasswordCreationForEmployeeRequested: 'AdminVaultPasswordCreationForEmployeeRequested',
    AdminVaultSharingToGroupRequested: 'AdminVaultSharingToGroupRequested',
    AdminVaultSharingToEmployeeAccountRequested: 'AdminVaultSharingToEmployeeAccountRequested',
    VaultPasswordRequestedForGroup: 'VaultPasswordRequestedForGroup',
    GetVaultPasswordDetailsViaTrustedBrowserRequested: 'GetVaultPasswordDetailsViaTrustedBrowserRequested',
    AdminVaultSecureNoteCreationForGroupRequested: 'AdminVaultSecureNoteCreationForGroupRequested',
    AdminVaultSecureNoteCreationForEmployeeRequested: 'AdminVaultSecureNoteCreationForEmployeeRequested',
    VaultSecureNoteEditRequestedForEmployee: 'VaultSecureNoteEditRequestedForEmployee',
    VaultSecureNoteRequested: 'VaultSecureNoteRequested',
    VaultSecureNoteRequestedForGroup: 'VaultSecureNoteRequestedForGroup',
    VaultPasswordCreationRequested: 'VaultPasswordCreationRequested',
    GetVaultPasswordDetailsForGroupViaTrustedBrowserRequested: 'GetVaultPasswordDetailsForGroupViaTrustedBrowserRequested',
    VaultSecureNoteCreationForGroupRequested: 'VaultSecureNoteCreationForGroupRequested',
    VaultSecureNoteCreationForEmployeeRequested: 'VaultSecureNoteCreationForEmployeeRequested',
    VaultSecureNoteEditRequestedForGroup: 'VaultSecureNoteEditRequestedForGroup',
    VaultPasswordEditRequestedForGroup: 'VaultPasswordEditRequestedForGroup',
    EmployeePromotedToAdmin: 'EmployeePromotedToAdmin',
    EmployeeDemotedFromAdmin: 'EmployeeDemotedFromAdmin',
    ApproveMasterPasswordResetRequest: 'ApproveMasterPasswordResetRequest',
    VaultCreditCardCreationForGroupRequested: 'VaultCreditCardCreationForGroupRequested',
    VaultCreditCardCreationForEmployeeRequested: 'VaultCreditCardCreationForEmployeeRequested',
    VaultCreditCardRequestedForEmployee: 'VaultCreditCardRequestedForEmployee',
    VaultCreditCardRequestedForGroup: 'VaultCreditCardRequestedForGroup',
    VaultCreditCardEditRequestedForEmployee: 'VaultCreditCardEditRequestedForEmployee',
    VaultCreditCardEditRequestedForGroup: 'VaultCreditCardEditRequestedForGroup',
    AdminVaultCreditCardCreationForGroupRequested: 'AdminVaultCreditCardCreationForGroupRequested',
    AdminVaultCreditCardCreationForEmployeeRequested: 'AdminVaultCreditCardCreationForEmployeeRequested',
    RevokeSharedVault: 'RevokeSharedVault',
    RevokeVaultSharing: 'RevokeVaultSharing',
    VaultRemoved: 'VaultRemoved',
    OrganizationEntriesChanged: 'OrganizationEntriesChanged',
    MoveVaultToPrivateKeychain: 'MoveVaultToPrivateKeychain',
    MoveVaultToEmployeeOrganizationKeychain: 'MoveVaultToEmployeeOrganizationKeychain',
    MoveVaultToGroupOrganizationKeychain: 'MoveVaultToGroupOrganizationKeychain',
    DeletePrivateKeychainVault: 'DeletePrivateKeychainVault',
    ExportVaultPassword: 'ExportVaultPassword',
    ProcessFirstAdminAsExistingUser: 'ProcessFirstAdminAsExistingUser',
    ProcessEmployeeAsExistingUser: 'ProcessEmployeeAsExistingUser',
    VaultSharingExpired: 'VaultSharingExpired',
    TrustedBrowserExpired: 'TrustedBrowserExpired',
    TrustedPortalRequested: 'TrustedPortalRequested',
    CreateTrustedBrowserRequestedV2: 'CreateTrustedBrowserRequestedV2',
    GetVaultPasswordDetailsViaTrustedBrowserRequestedV2: 'GetVaultPasswordDetailsViaTrustedBrowserRequestedV2',
    GetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedV2: 'GetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedV2',
    ProcessMigratedEmployee: 'ProcessMigratedEmployee',
    CreateTrustedBrowserRequestedV3: 'CreateTrustedBrowserRequestedV3',
    ImportVaultV2: 'ImportVaultV2',
    ExportVaultPasswordV2: 'ExportVaultPasswordV2',
    GetVaultPasswordDetailsViaTrustedBrowserRequestedV3: 'GetVaultPasswordDetailsViaTrustedBrowserRequestedV3',
    GetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedV3: 'GetVaultPasswordDetailsForGroupViaTrustedBrowserRequestedV3',
    CheckGeolocationRestrictions: 'CheckGeolocationRestrictions',
    VaultSecureNoteCreationRequested: 'VaultSecureNoteCreationRequested',
    VaultCreditCardCreationRequested: 'VaultCreditCardCreationRequested',
    BulkDeleteVaultsRequested: 'BulkDeleteVaultsRequested',
    PartnerSupporterRequestApproval: 'PartnerSupporterRequestApproval',
    MoveVaultToGroup: 'MoveVaultToGroup',
    FixEmployeePrivateKeys: 'FixEmployeePrivateKeys'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.RestoreBulkEmployeeAccountErrorDetails = {
    Undefined: 'Undefined',
    IsCurrentAdmin: 'IsCurrentAdmin',
    ActiveOrNotFound: 'ActiveOrNotFound',
    Unprocessed: 'Unprocessed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.RestrictionType = {
    IpAddress: 'IpAddress',
    Location: 'Location',
    Time: 'Time'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TrustedActionType = {
    TrustedBrowser: 'TrustedBrowser',
    TrustedPortal: 'TrustedPortal'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.VaultOrderProperty = {
    Name: 'Name',
    Username: 'Username',
    Strength: 'Strength',
    HasTotp: 'HasTotp',
    Ownership: 'Ownership',
    ApplicationName: 'ApplicationName',
    UsersCount: 'UsersCount',
    ActivityAt: 'ActivityAt'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.VaultSecureNotesOrderProperty = {
    Name: 'Name',
    Ownership: 'Ownership',
    ActivityAt: 'ActivityAt'
};
/**
 * ApplicationsApi - axios parameter creator
 * @export
 */
var ApplicationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsApplicationIdGet: function (applicationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([applicationId_1], args_1, true), void 0, function (applicationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'applicationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsApplicationIdGet', 'applicationId', applicationId);
                            localVarPath = "/api/v1/Applications/{applicationId}"
                                .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGet: function (page_1, pageLength_1, searchQuery_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, searchQuery_1], args_1, true), void 0, function (page, pageLength, searchQuery, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/Applications";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet: function (applicationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([applicationId_1], args_1, true), void 0, function (applicationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'applicationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet', 'applicationId', applicationId);
                            localVarPath = "/api/v1/Applications/GetDomainRulesAndDesktopApplicationsByApplicationId/{applicationId}"
                                .replace("{".concat("applicationId", "}"), encodeURIComponent(String(applicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} groupId
         * @param {number} [minStrength]
         * @param {number} [maxStrength]
         * @param {string} [searchQuery]
         * @param {ApplicationOrderPropertyName} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetServiceListForGroupGet: function (page_1, pageLength_1, groupId_1, minStrength_1, maxStrength_1, searchQuery_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, groupId_1, minStrength_1, maxStrength_1, searchQuery_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (page, pageLength, groupId, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsGetServiceListForGroupGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsGetServiceListForGroupGet', 'pageLength', pageLength);
                            // verify required parameter 'groupId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsGetServiceListForGroupGet', 'groupId', groupId);
                            localVarPath = "/api/v1/Applications/GetServiceListForGroup";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            if (minStrength !== undefined) {
                                localVarQueryParameter['MinStrength'] = minStrength;
                            }
                            if (maxStrength !== undefined) {
                                localVarQueryParameter['MaxStrength'] = maxStrength;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {number} [minStrength]
         * @param {number} [maxStrength]
         * @param {string} [searchQuery]
         * @param {ApplicationOrderPropertyName} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetServiceListGet: function (page_1, pageLength_1, minStrength_1, maxStrength_1, searchQuery_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 7; _i < arguments.length; _i++) {
                args_1[_i - 7] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, minStrength_1, maxStrength_1, searchQuery_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (page, pageLength, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsGetServiceListGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1ApplicationsGetServiceListGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/Applications/GetServiceList";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (minStrength !== undefined) {
                                localVarQueryParameter['MinStrength'] = minStrength;
                            }
                            if (maxStrength !== undefined) {
                                localVarQueryParameter['MaxStrength'] = maxStrength;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ApplicationsApiAxiosParamCreator = ApplicationsApiAxiosParamCreator;
/**
 * ApplicationsApi - functional programming interface
 * @export
 */
var ApplicationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ApplicationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsApplicationIdGet: function (applicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1ApplicationsApplicationIdGet(applicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGet: function (page, pageLength, searchQuery, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1ApplicationsGet(page, pageLength, searchQuery, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet: function (applicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet(applicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} groupId
         * @param {number} [minStrength]
         * @param {number} [maxStrength]
         * @param {string} [searchQuery]
         * @param {ApplicationOrderPropertyName} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetServiceListForGroupGet: function (page, pageLength, groupId, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1ApplicationsGetServiceListForGroupGet(page, pageLength, groupId, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {number} [minStrength]
         * @param {number} [maxStrength]
         * @param {string} [searchQuery]
         * @param {ApplicationOrderPropertyName} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetServiceListGet: function (page, pageLength, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1ApplicationsGetServiceListGet(page, pageLength, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ApplicationsApiFp = ApplicationsApiFp;
/**
 * ApplicationsApi - factory interface
 * @export
 */
var ApplicationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ApplicationsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsApplicationIdGet: function (applicationId, options) {
            return localVarFp.apiV1ApplicationsApplicationIdGet(applicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGet: function (page, pageLength, searchQuery, options) {
            return localVarFp.apiV1ApplicationsGet(page, pageLength, searchQuery, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} applicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet: function (applicationId, options) {
            return localVarFp.apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet(applicationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} groupId
         * @param {number} [minStrength]
         * @param {number} [maxStrength]
         * @param {string} [searchQuery]
         * @param {ApplicationOrderPropertyName} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetServiceListForGroupGet: function (page, pageLength, groupId, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1ApplicationsGetServiceListForGroupGet(page, pageLength, groupId, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {number} [minStrength]
         * @param {number} [maxStrength]
         * @param {string} [searchQuery]
         * @param {ApplicationOrderPropertyName} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ApplicationsGetServiceListGet: function (page, pageLength, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1ApplicationsGetServiceListGet(page, pageLength, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ApplicationsApiFactory = ApplicationsApiFactory;
/**
 * ApplicationsApi - object-oriented interface
 * @export
 * @class ApplicationsApi
 * @extends {BaseAPI}
 */
var ApplicationsApi = /** @class */ (function (_super) {
    __extends(ApplicationsApi, _super);
    function ApplicationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} applicationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.apiV1ApplicationsApplicationIdGet = function (applicationId, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).apiV1ApplicationsApplicationIdGet(applicationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} [searchQuery]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.apiV1ApplicationsGet = function (page, pageLength, searchQuery, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).apiV1ApplicationsGet(page, pageLength, searchQuery, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} applicationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet = function (applicationId, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).apiV1ApplicationsGetDomainRulesAndDesktopApplicationsByApplicationIdApplicationIdGet(applicationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} groupId
     * @param {number} [minStrength]
     * @param {number} [maxStrength]
     * @param {string} [searchQuery]
     * @param {ApplicationOrderPropertyName} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.apiV1ApplicationsGetServiceListForGroupGet = function (page, pageLength, groupId, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).apiV1ApplicationsGetServiceListForGroupGet(page, pageLength, groupId, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {number} [minStrength]
     * @param {number} [maxStrength]
     * @param {string} [searchQuery]
     * @param {ApplicationOrderPropertyName} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationsApi
     */
    ApplicationsApi.prototype.apiV1ApplicationsGetServiceListGet = function (page, pageLength, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.ApplicationsApiFp)(this.configuration).apiV1ApplicationsGetServiceListGet(page, pageLength, minStrength, maxStrength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ApplicationsApi;
}(base_1.BaseAPI));
exports.ApplicationsApi = ApplicationsApi;
/**
 * AuditLogsApi - axios parameter creator
 * @export
 */
var AuditLogsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [employeeAccountId]
         * @param {string} [beforeDate]
         * @param {string} [afterDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuditLogsGet: function (page_1, pageLength_1, employeeAccountId_1, beforeDate_1, afterDate_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, employeeAccountId_1, beforeDate_1, afterDate_1], args_1, true), void 0, function (page, pageLength, employeeAccountId, beforeDate, afterDate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1AuditLogsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1AuditLogsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/AuditLogs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (employeeAccountId !== undefined) {
                                localVarQueryParameter['EmployeeAccountId'] = employeeAccountId;
                            }
                            if (beforeDate !== undefined) {
                                localVarQueryParameter['BeforeDate'] = (beforeDate instanceof Date) ?
                                    beforeDate.toISOString() :
                                    beforeDate;
                            }
                            if (afterDate !== undefined) {
                                localVarQueryParameter['AfterDate'] = (afterDate instanceof Date) ?
                                    afterDate.toISOString() :
                                    afterDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AuditLogsApiAxiosParamCreator = AuditLogsApiAxiosParamCreator;
/**
 * AuditLogsApi - functional programming interface
 * @export
 */
var AuditLogsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AuditLogsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [employeeAccountId]
         * @param {string} [beforeDate]
         * @param {string} [afterDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuditLogsGet: function (page, pageLength, employeeAccountId, beforeDate, afterDate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1AuditLogsGet(page, pageLength, employeeAccountId, beforeDate, afterDate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AuditLogsApiFp = AuditLogsApiFp;
/**
 * AuditLogsApi - factory interface
 * @export
 */
var AuditLogsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AuditLogsApiFp)(configuration);
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [employeeAccountId]
         * @param {string} [beforeDate]
         * @param {string} [afterDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AuditLogsGet: function (page, pageLength, employeeAccountId, beforeDate, afterDate, options) {
            return localVarFp.apiV1AuditLogsGet(page, pageLength, employeeAccountId, beforeDate, afterDate, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AuditLogsApiFactory = AuditLogsApiFactory;
/**
 * AuditLogsApi - object-oriented interface
 * @export
 * @class AuditLogsApi
 * @extends {BaseAPI}
 */
var AuditLogsApi = /** @class */ (function (_super) {
    __extends(AuditLogsApi, _super);
    function AuditLogsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} [employeeAccountId]
     * @param {string} [beforeDate]
     * @param {string} [afterDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditLogsApi
     */
    AuditLogsApi.prototype.apiV1AuditLogsGet = function (page, pageLength, employeeAccountId, beforeDate, afterDate, options) {
        var _this = this;
        return (0, exports.AuditLogsApiFp)(this.configuration).apiV1AuditLogsGet(page, pageLength, employeeAccountId, beforeDate, afterDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuditLogsApi;
}(base_1.BaseAPI));
exports.AuditLogsApi = AuditLogsApi;
/**
 * CompanionApplicationApi - axios parameter creator
 * @export
 */
var CompanionApplicationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationCompanionApplicationIdDelete: function (companionApplicationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([companionApplicationId_1], args_1, true), void 0, function (companionApplicationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companionApplicationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1CompanionApplicationCompanionApplicationIdDelete', 'companionApplicationId', companionApplicationId);
                            localVarPath = "/api/v1/CompanionApplication/{companionApplicationId}"
                                .replace("{".concat("companionApplicationId", "}"), encodeURIComponent(String(companionApplicationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CompanionApplicationApiAxiosParamCreator = CompanionApplicationApiAxiosParamCreator;
/**
 * CompanionApplicationApi - functional programming interface
 * @export
 */
var CompanionApplicationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CompanionApplicationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationCompanionApplicationIdDelete: function (companionApplicationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1CompanionApplicationCompanionApplicationIdDelete(companionApplicationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CompanionApplicationApiFp = CompanionApplicationApiFp;
/**
 * CompanionApplicationApi - factory interface
 * @export
 */
var CompanionApplicationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CompanionApplicationApiFp)(configuration);
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CompanionApplicationCompanionApplicationIdDelete: function (companionApplicationId, options) {
            return localVarFp.apiV1CompanionApplicationCompanionApplicationIdDelete(companionApplicationId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CompanionApplicationApiFactory = CompanionApplicationApiFactory;
/**
 * CompanionApplicationApi - object-oriented interface
 * @export
 * @class CompanionApplicationApi
 * @extends {BaseAPI}
 */
var CompanionApplicationApi = /** @class */ (function (_super) {
    __extends(CompanionApplicationApi, _super);
    function CompanionApplicationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} companionApplicationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanionApplicationApi
     */
    CompanionApplicationApi.prototype.apiV1CompanionApplicationCompanionApplicationIdDelete = function (companionApplicationId, options) {
        var _this = this;
        return (0, exports.CompanionApplicationApiFp)(this.configuration).apiV1CompanionApplicationCompanionApplicationIdDelete(companionApplicationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CompanionApplicationApi;
}(base_1.BaseAPI));
exports.CompanionApplicationApi = CompanionApplicationApi;
/**
 * DashboardApi - axios parameter creator
 * @export
 */
var DashboardApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetActiveEmployeesRateGet: function (dateFrom_1, dateTo_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([dateFrom_1, dateTo_1], args_1, true), void 0, function (dateFrom, dateTo, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dateFrom' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1DashboardGetActiveEmployeesRateGet', 'dateFrom', dateFrom);
                            // verify required parameter 'dateTo' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1DashboardGetActiveEmployeesRateGet', 'dateTo', dateTo);
                            localVarPath = "/api/v1/Dashboard/GetActiveEmployeesRate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (dateFrom !== undefined) {
                                localVarQueryParameter['DateFrom'] = dateFrom;
                            }
                            if (dateTo !== undefined) {
                                localVarQueryParameter['DateTo'] = dateTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetAverageSecurityScoreGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Dashboard/GetAverageSecurityScore";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetEmployeeAccountsOnBoardGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Dashboard/GetEmployeeAccountsOnBoard";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetEmployeeActivationRateGet: function (dateFrom_1, dateTo_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([dateFrom_1, dateTo_1], args_1, true), void 0, function (dateFrom, dateTo, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dateFrom' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1DashboardGetEmployeeActivationRateGet', 'dateFrom', dateFrom);
                            // verify required parameter 'dateTo' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1DashboardGetEmployeeActivationRateGet', 'dateTo', dateTo);
                            localVarPath = "/api/v1/Dashboard/GetEmployeeActivationRate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (dateFrom !== undefined) {
                                localVarQueryParameter['DateFrom'] = dateFrom;
                            }
                            if (dateTo !== undefined) {
                                localVarQueryParameter['DateTo'] = dateTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetSecurityScoreRateGet: function (dateFrom_1, dateTo_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([dateFrom_1, dateTo_1], args_1, true), void 0, function (dateFrom, dateTo, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'dateFrom' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1DashboardGetSecurityScoreRateGet', 'dateFrom', dateFrom);
                            // verify required parameter 'dateTo' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1DashboardGetSecurityScoreRateGet', 'dateTo', dateTo);
                            localVarPath = "/api/v1/Dashboard/GetSecurityScoreRate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (dateFrom !== undefined) {
                                localVarQueryParameter['DateFrom'] = dateFrom;
                            }
                            if (dateTo !== undefined) {
                                localVarQueryParameter['DateTo'] = dateTo;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DashboardApiAxiosParamCreator = DashboardApiAxiosParamCreator;
/**
 * DashboardApi - functional programming interface
 * @export
 */
var DashboardApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DashboardApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetActiveEmployeesRateGet: function (dateFrom, dateTo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DashboardGetActiveEmployeesRateGet(dateFrom, dateTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetAverageSecurityScoreGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DashboardGetAverageSecurityScoreGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetEmployeeAccountsOnBoardGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DashboardGetEmployeeAccountsOnBoardGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetEmployeeActivationRateGet: function (dateFrom, dateTo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DashboardGetEmployeeActivationRateGet(dateFrom, dateTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetSecurityScoreRateGet: function (dateFrom, dateTo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DashboardGetSecurityScoreRateGet(dateFrom, dateTo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DashboardApiFp = DashboardApiFp;
/**
 * DashboardApi - factory interface
 * @export
 */
var DashboardApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DashboardApiFp)(configuration);
    return {
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetActiveEmployeesRateGet: function (dateFrom, dateTo, options) {
            return localVarFp.apiV1DashboardGetActiveEmployeesRateGet(dateFrom, dateTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetAverageSecurityScoreGet: function (options) {
            return localVarFp.apiV1DashboardGetAverageSecurityScoreGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetEmployeeAccountsOnBoardGet: function (options) {
            return localVarFp.apiV1DashboardGetEmployeeAccountsOnBoardGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetEmployeeActivationRateGet: function (dateFrom, dateTo, options) {
            return localVarFp.apiV1DashboardGetEmployeeActivationRateGet(dateFrom, dateTo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} dateFrom
         * @param {string} dateTo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DashboardGetSecurityScoreRateGet: function (dateFrom, dateTo, options) {
            return localVarFp.apiV1DashboardGetSecurityScoreRateGet(dateFrom, dateTo, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DashboardApiFactory = DashboardApiFactory;
/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
var DashboardApi = /** @class */ (function (_super) {
    __extends(DashboardApi, _super);
    function DashboardApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.apiV1DashboardGetActiveEmployeesRateGet = function (dateFrom, dateTo, options) {
        var _this = this;
        return (0, exports.DashboardApiFp)(this.configuration).apiV1DashboardGetActiveEmployeesRateGet(dateFrom, dateTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.apiV1DashboardGetAverageSecurityScoreGet = function (options) {
        var _this = this;
        return (0, exports.DashboardApiFp)(this.configuration).apiV1DashboardGetAverageSecurityScoreGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.apiV1DashboardGetEmployeeAccountsOnBoardGet = function (options) {
        var _this = this;
        return (0, exports.DashboardApiFp)(this.configuration).apiV1DashboardGetEmployeeAccountsOnBoardGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.apiV1DashboardGetEmployeeActivationRateGet = function (dateFrom, dateTo, options) {
        var _this = this;
        return (0, exports.DashboardApiFp)(this.configuration).apiV1DashboardGetEmployeeActivationRateGet(dateFrom, dateTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} dateFrom
     * @param {string} dateTo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    DashboardApi.prototype.apiV1DashboardGetSecurityScoreRateGet = function (dateFrom, dateTo, options) {
        var _this = this;
        return (0, exports.DashboardApiFp)(this.configuration).apiV1DashboardGetSecurityScoreRateGet(dateFrom, dateTo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DashboardApi;
}(base_1.BaseAPI));
exports.DashboardApi = DashboardApi;
/**
 * DesktopApplicationsApi - axios parameter creator
 * @export
 */
var DesktopApplicationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [desktopAppName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DesktopApplicationsSearchByDesktopAppNameGet: function (desktopAppName_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([desktopAppName_1], args_1, true), void 0, function (desktopAppName, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/DesktopApplications/SearchByDesktopAppName";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (desktopAppName !== undefined) {
                                localVarQueryParameter['DesktopAppName'] = desktopAppName;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DesktopApplicationsApiAxiosParamCreator = DesktopApplicationsApiAxiosParamCreator;
/**
 * DesktopApplicationsApi - functional programming interface
 * @export
 */
var DesktopApplicationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DesktopApplicationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [desktopAppName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DesktopApplicationsSearchByDesktopAppNameGet: function (desktopAppName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DesktopApplicationsSearchByDesktopAppNameGet(desktopAppName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DesktopApplicationsApiFp = DesktopApplicationsApiFp;
/**
 * DesktopApplicationsApi - factory interface
 * @export
 */
var DesktopApplicationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DesktopApplicationsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [desktopAppName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DesktopApplicationsSearchByDesktopAppNameGet: function (desktopAppName, options) {
            return localVarFp.apiV1DesktopApplicationsSearchByDesktopAppNameGet(desktopAppName, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DesktopApplicationsApiFactory = DesktopApplicationsApiFactory;
/**
 * DesktopApplicationsApi - object-oriented interface
 * @export
 * @class DesktopApplicationsApi
 * @extends {BaseAPI}
 */
var DesktopApplicationsApi = /** @class */ (function (_super) {
    __extends(DesktopApplicationsApi, _super);
    function DesktopApplicationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [desktopAppName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesktopApplicationsApi
     */
    DesktopApplicationsApi.prototype.apiV1DesktopApplicationsSearchByDesktopAppNameGet = function (desktopAppName, options) {
        var _this = this;
        return (0, exports.DesktopApplicationsApiFp)(this.configuration).apiV1DesktopApplicationsSearchByDesktopAppNameGet(desktopAppName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DesktopApplicationsApi;
}(base_1.BaseAPI));
exports.DesktopApplicationsApi = DesktopApplicationsApi;
/**
 * DomainRulesApi - axios parameter creator
 * @export
 */
var DomainRulesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DomainRulesSearchByUrlGet: function (url_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([url_1], args_1, true), void 0, function (url, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/DomainRules/SearchByUrl";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (url !== undefined) {
                                localVarQueryParameter['url'] = url;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DomainRulesApiAxiosParamCreator = DomainRulesApiAxiosParamCreator;
/**
 * DomainRulesApi - functional programming interface
 * @export
 */
var DomainRulesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DomainRulesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DomainRulesSearchByUrlGet: function (url, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1DomainRulesSearchByUrlGet(url, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DomainRulesApiFp = DomainRulesApiFp;
/**
 * DomainRulesApi - factory interface
 * @export
 */
var DomainRulesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DomainRulesApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [url]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DomainRulesSearchByUrlGet: function (url, options) {
            return localVarFp.apiV1DomainRulesSearchByUrlGet(url, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DomainRulesApiFactory = DomainRulesApiFactory;
/**
 * DomainRulesApi - object-oriented interface
 * @export
 * @class DomainRulesApi
 * @extends {BaseAPI}
 */
var DomainRulesApi = /** @class */ (function (_super) {
    __extends(DomainRulesApi, _super);
    function DomainRulesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [url]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainRulesApi
     */
    DomainRulesApi.prototype.apiV1DomainRulesSearchByUrlGet = function (url, options) {
        var _this = this;
        return (0, exports.DomainRulesApiFp)(this.configuration).apiV1DomainRulesSearchByUrlGet(url, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DomainRulesApi;
}(base_1.BaseAPI));
exports.DomainRulesApi = DomainRulesApi;
/**
 * EmployeeAccountsApi - axios parameter creator
 * @export
 */
var EmployeeAccountsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {ArchiveBulkEmployeeAccountRequest} [archiveBulkEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsArchiveBulkPost: function (archiveBulkEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([archiveBulkEmployeeAccountRequest_1], args_1, true), void 0, function (archiveBulkEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/ArchiveBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(archiveBulkEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {SendBulkInviteRequest} [sendBulkInviteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsBulkSendInvitesPost: function (sendBulkInviteRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([sendBulkInviteRequest_1], args_1, true), void 0, function (sendBulkInviteRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/BulkSendInvites";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sendBulkInviteRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkEmployeeAccountRequest} [deleteBulkEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsDeleteBulkPost: function (deleteBulkEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteBulkEmployeeAccountRequest_1], args_1, true), void 0, function (deleteBulkEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/DeleteBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteBulkEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsEmployeeAccountIdGet: function (employeeAccountId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1], args_1, true), void 0, function (employeeAccountId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'employeeAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsEmployeeAccountIdGet', 'employeeAccountId', employeeAccountId);
                            localVarPath = "/api/v1/EmployeeAccounts/{employeeAccountId}"
                                .replace("{".concat("employeeAccountId", "}"), encodeURIComponent(String(employeeAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsEmployeeAccountIdPatch: function (employeeAccountId_1, operation_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1, operation_1], args_1, true), void 0, function (employeeAccountId, operation, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'employeeAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsEmployeeAccountIdPatch', 'employeeAccountId', employeeAccountId);
                            localVarPath = "/api/v1/EmployeeAccounts/{employeeAccountId}"
                                .replace("{".concat("employeeAccountId", "}"), encodeURIComponent(String(employeeAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(operation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {EmployeeAccountType} [typeFilter]
         * @param {string} [groupId]
         * @param {EmployeeAccountStatus} [statusFilter]
         * @param {string} [searchQuery]
         * @param {EmployeeAccountOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {boolean} [showSupporters]
         * @param {number} [maxStrength]
         * @param {number} [minStrength]
         * @param {ActivityFilter} [activityFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGet: function (page_1, pageLength_1, typeFilter_1, groupId_1, statusFilter_1, searchQuery_1, orderPropertyName_1, isDescending_1, showSupporters_1, maxStrength_1, minStrength_1, activityFilter_1) {
            var args_1 = [];
            for (var _i = 12; _i < arguments.length; _i++) {
                args_1[_i - 12] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, typeFilter_1, groupId_1, statusFilter_1, searchQuery_1, orderPropertyName_1, isDescending_1, showSupporters_1, maxStrength_1, minStrength_1, activityFilter_1], args_1, true), void 0, function (page, pageLength, typeFilter, groupId, statusFilter, searchQuery, orderPropertyName, isDescending, showSupporters, maxStrength, minStrength, activityFilter, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/EmployeeAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (typeFilter !== undefined) {
                                localVarQueryParameter['TypeFilter'] = typeFilter;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            if (statusFilter !== undefined) {
                                localVarQueryParameter['StatusFilter'] = statusFilter;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            if (showSupporters !== undefined) {
                                localVarQueryParameter['ShowSupporters'] = showSupporters;
                            }
                            if (maxStrength !== undefined) {
                                localVarQueryParameter['MaxStrength'] = maxStrength;
                            }
                            if (minStrength !== undefined) {
                                localVarQueryParameter['MinStrength'] = minStrength;
                            }
                            if (activityFilter !== undefined) {
                                localVarQueryParameter['ActivityFilter'] = activityFilter;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetAverageSecurityScoreEmployeeAccountIdGet: function (employeeAccountId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1], args_1, true), void 0, function (employeeAccountId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'employeeAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetAverageSecurityScoreEmployeeAccountIdGet', 'employeeAccountId', employeeAccountId);
                            localVarPath = "/api/v1/EmployeeAccounts/GetAverageSecurityScore/{employeeAccountId}"
                                .replace("{".concat("employeeAccountId", "}"), encodeURIComponent(String(employeeAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} applicationId
         * @param {string} [searchQuery]
         * @param {EmployeeByApplicationOrderPropertyName} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetByApplicationIdGet: function (page_1, pageLength_1, applicationId_1, searchQuery_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, applicationId_1, searchQuery_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (page, pageLength, applicationId, searchQuery, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetByApplicationIdGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetByApplicationIdGet', 'pageLength', pageLength);
                            // verify required parameter 'applicationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetByApplicationIdGet', 'applicationId', applicationId);
                            localVarPath = "/api/v1/EmployeeAccounts/GetByApplicationId";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (applicationId !== undefined) {
                                localVarQueryParameter['ApplicationId'] = applicationId;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetJwksGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/GetJwks";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetManagedByEmployeesByVaultIdOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetManagedByEmployeesByVaultIdVaultIdGet: function (vaultId_1, page_1, pageLength_1, searchQuery_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, page_1, pageLength_1, searchQuery_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetManagedByEmployeesByVaultIdVaultIdGet', 'vaultId', vaultId);
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetManagedByEmployeesByVaultIdVaultIdGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetManagedByEmployeesByVaultIdVaultIdGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/EmployeeAccounts/GetManagedByEmployeesByVaultId/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetManagedByGroupsByVaultIdOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetManagedByGroupsByVaultIdVaultIdGet: function (vaultId_1, page_1, pageLength_1, searchQuery_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1, page_1, pageLength_1, searchQuery_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetManagedByGroupsByVaultIdVaultIdGet', 'vaultId', vaultId);
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetManagedByGroupsByVaultIdVaultIdGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1EmployeeAccountsGetManagedByGroupsByVaultIdVaultIdGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/EmployeeAccounts/GetManagedByGroupsByVaultId/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetUnprocessedSCIMUsersCountGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/GetUnprocessedSCIMUsersCount";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {InviteEmployeeRequest} [inviteEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsInviteBulkPost: function (inviteEmployeeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([inviteEmployeeRequest_1], args_1, true), void 0, function (inviteEmployeeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/InviteBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inviteEmployeeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsMeGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/Me";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [employeeAccountId]
         * @param {EncryptionKeyType} [encryptionKeyType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsPromoteAdminPost: function (employeeAccountId_1, encryptionKeyType_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1, encryptionKeyType_1], args_1, true), void 0, function (employeeAccountId, encryptionKeyType, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/PromoteAdmin";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (employeeAccountId !== undefined) {
                                localVarQueryParameter['employeeAccountId'] = employeeAccountId;
                            }
                            if (encryptionKeyType !== undefined) {
                                localVarQueryParameter['encryptionKeyType'] = encryptionKeyType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RestoreBulkEmployeeAccountRequest} [restoreBulkEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRestoreBulkPost: function (restoreBulkEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([restoreBulkEmployeeAccountRequest_1], args_1, true), void 0, function (restoreBulkEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/RestoreBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(restoreBulkEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [employeeAccountId]
         * @param {EncryptionKeyType} [encryptionKeyType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRevokeAdminPost: function (employeeAccountId_1, encryptionKeyType_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([employeeAccountId_1, encryptionKeyType_1], args_1, true), void 0, function (employeeAccountId, encryptionKeyType, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccounts/RevokeAdmin";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (employeeAccountId !== undefined) {
                                localVarQueryParameter['employeeAccountId'] = employeeAccountId;
                            }
                            if (encryptionKeyType !== undefined) {
                                localVarQueryParameter['encryptionKeyType'] = encryptionKeyType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EmployeeAccountsApiAxiosParamCreator = EmployeeAccountsApiAxiosParamCreator;
/**
 * EmployeeAccountsApi - functional programming interface
 * @export
 */
var EmployeeAccountsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EmployeeAccountsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ArchiveBulkEmployeeAccountRequest} [archiveBulkEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsArchiveBulkPost: function (archiveBulkEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsArchiveBulkPost(archiveBulkEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {SendBulkInviteRequest} [sendBulkInviteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsBulkSendInvitesPost: function (sendBulkInviteRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsBulkSendInvitesPost(sendBulkInviteRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkEmployeeAccountRequest} [deleteBulkEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsDeleteBulkPost: function (deleteBulkEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsDeleteBulkPost(deleteBulkEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsEmployeeAccountIdGet: function (employeeAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsEmployeeAccountIdGet(employeeAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsEmployeeAccountIdPatch: function (employeeAccountId, operation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsEmployeeAccountIdPatch(employeeAccountId, operation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {EmployeeAccountType} [typeFilter]
         * @param {string} [groupId]
         * @param {EmployeeAccountStatus} [statusFilter]
         * @param {string} [searchQuery]
         * @param {EmployeeAccountOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {boolean} [showSupporters]
         * @param {number} [maxStrength]
         * @param {number} [minStrength]
         * @param {ActivityFilter} [activityFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGet: function (page, pageLength, typeFilter, groupId, statusFilter, searchQuery, orderPropertyName, isDescending, showSupporters, maxStrength, minStrength, activityFilter, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGet(page, pageLength, typeFilter, groupId, statusFilter, searchQuery, orderPropertyName, isDescending, showSupporters, maxStrength, minStrength, activityFilter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetAverageSecurityScoreEmployeeAccountIdGet: function (employeeAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetAverageSecurityScoreEmployeeAccountIdGet(employeeAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} applicationId
         * @param {string} [searchQuery]
         * @param {EmployeeByApplicationOrderPropertyName} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetByApplicationIdGet: function (page, pageLength, applicationId, searchQuery, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetByApplicationIdGet(page, pageLength, applicationId, searchQuery, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetJwksGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetJwksGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetManagedByEmployeesByVaultIdOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetManagedByEmployeesByVaultIdVaultIdGet: function (vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetManagedByEmployeesByVaultIdVaultIdGet(vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetManagedByGroupsByVaultIdOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetManagedByGroupsByVaultIdVaultIdGet: function (vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetManagedByGroupsByVaultIdVaultIdGet(vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetUnprocessedSCIMUsersCountGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsGetUnprocessedSCIMUsersCountGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {InviteEmployeeRequest} [inviteEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsInviteBulkPost: function (inviteEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsInviteBulkPost(inviteEmployeeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [employeeAccountId]
         * @param {EncryptionKeyType} [encryptionKeyType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsPromoteAdminPost: function (employeeAccountId, encryptionKeyType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsPromoteAdminPost(employeeAccountId, encryptionKeyType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RestoreBulkEmployeeAccountRequest} [restoreBulkEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRestoreBulkPost: function (restoreBulkEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsRestoreBulkPost(restoreBulkEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [employeeAccountId]
         * @param {EncryptionKeyType} [encryptionKeyType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRevokeAdminPost: function (employeeAccountId, encryptionKeyType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsRevokeAdminPost(employeeAccountId, encryptionKeyType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.EmployeeAccountsApiFp = EmployeeAccountsApiFp;
/**
 * EmployeeAccountsApi - factory interface
 * @export
 */
var EmployeeAccountsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EmployeeAccountsApiFp)(configuration);
    return {
        /**
         *
         * @param {ArchiveBulkEmployeeAccountRequest} [archiveBulkEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsArchiveBulkPost: function (archiveBulkEmployeeAccountRequest, options) {
            return localVarFp.apiV1EmployeeAccountsArchiveBulkPost(archiveBulkEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {SendBulkInviteRequest} [sendBulkInviteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsBulkSendInvitesPost: function (sendBulkInviteRequest, options) {
            return localVarFp.apiV1EmployeeAccountsBulkSendInvitesPost(sendBulkInviteRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeleteBulkEmployeeAccountRequest} [deleteBulkEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsDeleteBulkPost: function (deleteBulkEmployeeAccountRequest, options) {
            return localVarFp.apiV1EmployeeAccountsDeleteBulkPost(deleteBulkEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsEmployeeAccountIdGet: function (employeeAccountId, options) {
            return localVarFp.apiV1EmployeeAccountsEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsEmployeeAccountIdPatch: function (employeeAccountId, operation, options) {
            return localVarFp.apiV1EmployeeAccountsEmployeeAccountIdPatch(employeeAccountId, operation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {EmployeeAccountType} [typeFilter]
         * @param {string} [groupId]
         * @param {EmployeeAccountStatus} [statusFilter]
         * @param {string} [searchQuery]
         * @param {EmployeeAccountOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {boolean} [showSupporters]
         * @param {number} [maxStrength]
         * @param {number} [minStrength]
         * @param {ActivityFilter} [activityFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGet: function (page, pageLength, typeFilter, groupId, statusFilter, searchQuery, orderPropertyName, isDescending, showSupporters, maxStrength, minStrength, activityFilter, options) {
            return localVarFp.apiV1EmployeeAccountsGet(page, pageLength, typeFilter, groupId, statusFilter, searchQuery, orderPropertyName, isDescending, showSupporters, maxStrength, minStrength, activityFilter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} employeeAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetAverageSecurityScoreEmployeeAccountIdGet: function (employeeAccountId, options) {
            return localVarFp.apiV1EmployeeAccountsGetAverageSecurityScoreEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} applicationId
         * @param {string} [searchQuery]
         * @param {EmployeeByApplicationOrderPropertyName} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetByApplicationIdGet: function (page, pageLength, applicationId, searchQuery, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1EmployeeAccountsGetByApplicationIdGet(page, pageLength, applicationId, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetJwksGet: function (options) {
            return localVarFp.apiV1EmployeeAccountsGetJwksGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetManagedByEmployeesByVaultIdOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetManagedByEmployeesByVaultIdVaultIdGet: function (vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1EmployeeAccountsGetManagedByEmployeesByVaultIdVaultIdGet(vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetManagedByGroupsByVaultIdOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetManagedByGroupsByVaultIdVaultIdGet: function (vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1EmployeeAccountsGetManagedByGroupsByVaultIdVaultIdGet(vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsGetUnprocessedSCIMUsersCountGet: function (options) {
            return localVarFp.apiV1EmployeeAccountsGetUnprocessedSCIMUsersCountGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {InviteEmployeeRequest} [inviteEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsInviteBulkPost: function (inviteEmployeeRequest, options) {
            return localVarFp.apiV1EmployeeAccountsInviteBulkPost(inviteEmployeeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsMeGet: function (options) {
            return localVarFp.apiV1EmployeeAccountsMeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [employeeAccountId]
         * @param {EncryptionKeyType} [encryptionKeyType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsPromoteAdminPost: function (employeeAccountId, encryptionKeyType, options) {
            return localVarFp.apiV1EmployeeAccountsPromoteAdminPost(employeeAccountId, encryptionKeyType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RestoreBulkEmployeeAccountRequest} [restoreBulkEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRestoreBulkPost: function (restoreBulkEmployeeAccountRequest, options) {
            return localVarFp.apiV1EmployeeAccountsRestoreBulkPost(restoreBulkEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [employeeAccountId]
         * @param {EncryptionKeyType} [encryptionKeyType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsRevokeAdminPost: function (employeeAccountId, encryptionKeyType, options) {
            return localVarFp.apiV1EmployeeAccountsRevokeAdminPost(employeeAccountId, encryptionKeyType, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EmployeeAccountsApiFactory = EmployeeAccountsApiFactory;
/**
 * EmployeeAccountsApi - object-oriented interface
 * @export
 * @class EmployeeAccountsApi
 * @extends {BaseAPI}
 */
var EmployeeAccountsApi = /** @class */ (function (_super) {
    __extends(EmployeeAccountsApi, _super);
    function EmployeeAccountsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {ArchiveBulkEmployeeAccountRequest} [archiveBulkEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsArchiveBulkPost = function (archiveBulkEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsArchiveBulkPost(archiveBulkEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {SendBulkInviteRequest} [sendBulkInviteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsBulkSendInvitesPost = function (sendBulkInviteRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsBulkSendInvitesPost(sendBulkInviteRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeleteBulkEmployeeAccountRequest} [deleteBulkEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsDeleteBulkPost = function (deleteBulkEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsDeleteBulkPost(deleteBulkEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} employeeAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsEmployeeAccountIdGet = function (employeeAccountId, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} employeeAccountId
     * @param {Array<Operation>} [operation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsEmployeeAccountIdPatch = function (employeeAccountId, operation, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsEmployeeAccountIdPatch(employeeAccountId, operation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {EmployeeAccountType} [typeFilter]
     * @param {string} [groupId]
     * @param {EmployeeAccountStatus} [statusFilter]
     * @param {string} [searchQuery]
     * @param {EmployeeAccountOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {boolean} [showSupporters]
     * @param {number} [maxStrength]
     * @param {number} [minStrength]
     * @param {ActivityFilter} [activityFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGet = function (page, pageLength, typeFilter, groupId, statusFilter, searchQuery, orderPropertyName, isDescending, showSupporters, maxStrength, minStrength, activityFilter, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGet(page, pageLength, typeFilter, groupId, statusFilter, searchQuery, orderPropertyName, isDescending, showSupporters, maxStrength, minStrength, activityFilter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} employeeAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetAverageSecurityScoreEmployeeAccountIdGet = function (employeeAccountId, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetAverageSecurityScoreEmployeeAccountIdGet(employeeAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} applicationId
     * @param {string} [searchQuery]
     * @param {EmployeeByApplicationOrderPropertyName} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetByApplicationIdGet = function (page, pageLength, applicationId, searchQuery, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetByApplicationIdGet(page, pageLength, applicationId, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetJwksGet = function (options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetJwksGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {number} page
     * @param {number} pageLength
     * @param {string} [searchQuery]
     * @param {GetManagedByEmployeesByVaultIdOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetManagedByEmployeesByVaultIdVaultIdGet = function (vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetManagedByEmployeesByVaultIdVaultIdGet(vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {number} page
     * @param {number} pageLength
     * @param {string} [searchQuery]
     * @param {GetManagedByGroupsByVaultIdOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetManagedByGroupsByVaultIdVaultIdGet = function (vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetManagedByGroupsByVaultIdVaultIdGet(vaultId, page, pageLength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsGetUnprocessedSCIMUsersCountGet = function (options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsGetUnprocessedSCIMUsersCountGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {InviteEmployeeRequest} [inviteEmployeeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsInviteBulkPost = function (inviteEmployeeRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsInviteBulkPost(inviteEmployeeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsMeGet = function (options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [employeeAccountId]
     * @param {EncryptionKeyType} [encryptionKeyType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsPromoteAdminPost = function (employeeAccountId, encryptionKeyType, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsPromoteAdminPost(employeeAccountId, encryptionKeyType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RestoreBulkEmployeeAccountRequest} [restoreBulkEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsRestoreBulkPost = function (restoreBulkEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsRestoreBulkPost(restoreBulkEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [employeeAccountId]
     * @param {EncryptionKeyType} [encryptionKeyType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsApi
     */
    EmployeeAccountsApi.prototype.apiV1EmployeeAccountsRevokeAdminPost = function (employeeAccountId, encryptionKeyType, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsApiFp)(this.configuration).apiV1EmployeeAccountsRevokeAdminPost(employeeAccountId, encryptionKeyType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EmployeeAccountsApi;
}(base_1.BaseAPI));
exports.EmployeeAccountsApi = EmployeeAccountsApi;
/**
 * EmployeeAccountsToGroupsApi - axios parameter creator
 * @export
 */
var EmployeeAccountsToGroupsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {AttachEmployeeAccountRequest} [attachEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsAttachEmployeeAccountBulkPost: function (attachEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([attachEmployeeAccountRequest_1], args_1, true), void 0, function (attachEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccountsToGroups/AttachEmployeeAccountBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(attachEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DetachBulkEmployeeAccountsToGroupRequest} [detachBulkEmployeeAccountsToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsDetachBulkPost: function (detachBulkEmployeeAccountsToGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([detachBulkEmployeeAccountsToGroupRequest_1], args_1, true), void 0, function (detachBulkEmployeeAccountsToGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/EmployeeAccountsToGroups/DetachBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(detachBulkEmployeeAccountsToGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.EmployeeAccountsToGroupsApiAxiosParamCreator = EmployeeAccountsToGroupsApiAxiosParamCreator;
/**
 * EmployeeAccountsToGroupsApi - functional programming interface
 * @export
 */
var EmployeeAccountsToGroupsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EmployeeAccountsToGroupsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AttachEmployeeAccountRequest} [attachEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsAttachEmployeeAccountBulkPost: function (attachEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsToGroupsAttachEmployeeAccountBulkPost(attachEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DetachBulkEmployeeAccountsToGroupRequest} [detachBulkEmployeeAccountsToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsDetachBulkPost: function (detachBulkEmployeeAccountsToGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1EmployeeAccountsToGroupsDetachBulkPost(detachBulkEmployeeAccountsToGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.EmployeeAccountsToGroupsApiFp = EmployeeAccountsToGroupsApiFp;
/**
 * EmployeeAccountsToGroupsApi - factory interface
 * @export
 */
var EmployeeAccountsToGroupsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EmployeeAccountsToGroupsApiFp)(configuration);
    return {
        /**
         *
         * @param {AttachEmployeeAccountRequest} [attachEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsAttachEmployeeAccountBulkPost: function (attachEmployeeAccountRequest, options) {
            return localVarFp.apiV1EmployeeAccountsToGroupsAttachEmployeeAccountBulkPost(attachEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DetachBulkEmployeeAccountsToGroupRequest} [detachBulkEmployeeAccountsToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EmployeeAccountsToGroupsDetachBulkPost: function (detachBulkEmployeeAccountsToGroupRequest, options) {
            return localVarFp.apiV1EmployeeAccountsToGroupsDetachBulkPost(detachBulkEmployeeAccountsToGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EmployeeAccountsToGroupsApiFactory = EmployeeAccountsToGroupsApiFactory;
/**
 * EmployeeAccountsToGroupsApi - object-oriented interface
 * @export
 * @class EmployeeAccountsToGroupsApi
 * @extends {BaseAPI}
 */
var EmployeeAccountsToGroupsApi = /** @class */ (function (_super) {
    __extends(EmployeeAccountsToGroupsApi, _super);
    function EmployeeAccountsToGroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {AttachEmployeeAccountRequest} [attachEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsToGroupsApi
     */
    EmployeeAccountsToGroupsApi.prototype.apiV1EmployeeAccountsToGroupsAttachEmployeeAccountBulkPost = function (attachEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsToGroupsApiFp)(this.configuration).apiV1EmployeeAccountsToGroupsAttachEmployeeAccountBulkPost(attachEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DetachBulkEmployeeAccountsToGroupRequest} [detachBulkEmployeeAccountsToGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeAccountsToGroupsApi
     */
    EmployeeAccountsToGroupsApi.prototype.apiV1EmployeeAccountsToGroupsDetachBulkPost = function (detachBulkEmployeeAccountsToGroupRequest, options) {
        var _this = this;
        return (0, exports.EmployeeAccountsToGroupsApiFp)(this.configuration).apiV1EmployeeAccountsToGroupsDetachBulkPost(detachBulkEmployeeAccountsToGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EmployeeAccountsToGroupsApi;
}(base_1.BaseAPI));
exports.EmployeeAccountsToGroupsApi = EmployeeAccountsToGroupsApi;
/**
 * GeolocationGroupRestrictionsApi - axios parameter creator
 * @export
 */
var GeolocationGroupRestrictionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} groupRestrictionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeolocationGroupRestrictionsGroupRestrictionIdGet: function (groupRestrictionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([groupRestrictionId_1], args_1, true), void 0, function (groupRestrictionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'groupRestrictionId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GeolocationGroupRestrictionsGroupRestrictionIdGet', 'groupRestrictionId', groupRestrictionId);
                            localVarPath = "/api/v1/GeolocationGroupRestrictions/{groupRestrictionId}"
                                .replace("{".concat("groupRestrictionId", "}"), encodeURIComponent(String(groupRestrictionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupRestrictionId
         * @param {PatchGeolocationGroupRestrictionRequest} [patchGeolocationGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeolocationGroupRestrictionsGroupRestrictionIdPatch: function (groupRestrictionId_1, patchGeolocationGroupRestrictionRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([groupRestrictionId_1, patchGeolocationGroupRestrictionRequest_1], args_1, true), void 0, function (groupRestrictionId, patchGeolocationGroupRestrictionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'groupRestrictionId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GeolocationGroupRestrictionsGroupRestrictionIdPatch', 'groupRestrictionId', groupRestrictionId);
                            localVarPath = "/api/v1/GeolocationGroupRestrictions/{groupRestrictionId}"
                                .replace("{".concat("groupRestrictionId", "}"), encodeURIComponent(String(groupRestrictionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchGeolocationGroupRestrictionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateGeolocationGroupRestrictionRequest} [createGeolocationGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeolocationGroupRestrictionsPost: function (createGeolocationGroupRestrictionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createGeolocationGroupRestrictionRequest_1], args_1, true), void 0, function (createGeolocationGroupRestrictionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/GeolocationGroupRestrictions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createGeolocationGroupRestrictionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.GeolocationGroupRestrictionsApiAxiosParamCreator = GeolocationGroupRestrictionsApiAxiosParamCreator;
/**
 * GeolocationGroupRestrictionsApi - functional programming interface
 * @export
 */
var GeolocationGroupRestrictionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GeolocationGroupRestrictionsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} groupRestrictionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeolocationGroupRestrictionsGroupRestrictionIdGet: function (groupRestrictionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GeolocationGroupRestrictionsGroupRestrictionIdGet(groupRestrictionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupRestrictionId
         * @param {PatchGeolocationGroupRestrictionRequest} [patchGeolocationGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeolocationGroupRestrictionsGroupRestrictionIdPatch: function (groupRestrictionId, patchGeolocationGroupRestrictionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GeolocationGroupRestrictionsGroupRestrictionIdPatch(groupRestrictionId, patchGeolocationGroupRestrictionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateGeolocationGroupRestrictionRequest} [createGeolocationGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeolocationGroupRestrictionsPost: function (createGeolocationGroupRestrictionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GeolocationGroupRestrictionsPost(createGeolocationGroupRestrictionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GeolocationGroupRestrictionsApiFp = GeolocationGroupRestrictionsApiFp;
/**
 * GeolocationGroupRestrictionsApi - factory interface
 * @export
 */
var GeolocationGroupRestrictionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GeolocationGroupRestrictionsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} groupRestrictionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeolocationGroupRestrictionsGroupRestrictionIdGet: function (groupRestrictionId, options) {
            return localVarFp.apiV1GeolocationGroupRestrictionsGroupRestrictionIdGet(groupRestrictionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} groupRestrictionId
         * @param {PatchGeolocationGroupRestrictionRequest} [patchGeolocationGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeolocationGroupRestrictionsGroupRestrictionIdPatch: function (groupRestrictionId, patchGeolocationGroupRestrictionRequest, options) {
            return localVarFp.apiV1GeolocationGroupRestrictionsGroupRestrictionIdPatch(groupRestrictionId, patchGeolocationGroupRestrictionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateGeolocationGroupRestrictionRequest} [createGeolocationGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GeolocationGroupRestrictionsPost: function (createGeolocationGroupRestrictionRequest, options) {
            return localVarFp.apiV1GeolocationGroupRestrictionsPost(createGeolocationGroupRestrictionRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GeolocationGroupRestrictionsApiFactory = GeolocationGroupRestrictionsApiFactory;
/**
 * GeolocationGroupRestrictionsApi - object-oriented interface
 * @export
 * @class GeolocationGroupRestrictionsApi
 * @extends {BaseAPI}
 */
var GeolocationGroupRestrictionsApi = /** @class */ (function (_super) {
    __extends(GeolocationGroupRestrictionsApi, _super);
    function GeolocationGroupRestrictionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} groupRestrictionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationGroupRestrictionsApi
     */
    GeolocationGroupRestrictionsApi.prototype.apiV1GeolocationGroupRestrictionsGroupRestrictionIdGet = function (groupRestrictionId, options) {
        var _this = this;
        return (0, exports.GeolocationGroupRestrictionsApiFp)(this.configuration).apiV1GeolocationGroupRestrictionsGroupRestrictionIdGet(groupRestrictionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} groupRestrictionId
     * @param {PatchGeolocationGroupRestrictionRequest} [patchGeolocationGroupRestrictionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationGroupRestrictionsApi
     */
    GeolocationGroupRestrictionsApi.prototype.apiV1GeolocationGroupRestrictionsGroupRestrictionIdPatch = function (groupRestrictionId, patchGeolocationGroupRestrictionRequest, options) {
        var _this = this;
        return (0, exports.GeolocationGroupRestrictionsApiFp)(this.configuration).apiV1GeolocationGroupRestrictionsGroupRestrictionIdPatch(groupRestrictionId, patchGeolocationGroupRestrictionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateGeolocationGroupRestrictionRequest} [createGeolocationGroupRestrictionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationGroupRestrictionsApi
     */
    GeolocationGroupRestrictionsApi.prototype.apiV1GeolocationGroupRestrictionsPost = function (createGeolocationGroupRestrictionRequest, options) {
        var _this = this;
        return (0, exports.GeolocationGroupRestrictionsApiFp)(this.configuration).apiV1GeolocationGroupRestrictionsPost(createGeolocationGroupRestrictionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GeolocationGroupRestrictionsApi;
}(base_1.BaseAPI));
exports.GeolocationGroupRestrictionsApi = GeolocationGroupRestrictionsApi;
/**
 * GroupRestrictionsApi - axios parameter creator
 * @export
 */
var GroupRestrictionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {DeleteBulkGroupRestrictionRequest} [deleteBulkGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsDeleteBulkPost: function (deleteBulkGroupRestrictionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteBulkGroupRestrictionRequest_1], args_1, true), void 0, function (deleteBulkGroupRestrictionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/GroupRestrictions/DeleteBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteBulkGroupRestrictionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGetGet: function (page_1, pageLength_1, groupId_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, groupId_1], args_1, true), void 0, function (page, pageLength, groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupRestrictionsGetGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupRestrictionsGetGet', 'pageLength', pageLength);
                            // verify required parameter 'groupId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupRestrictionsGetGet', 'groupId', groupId);
                            localVarPath = "/api/v1/GroupRestrictions/Get";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {ToggleGroupRestrictionRequest} [toggleGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsTogglePost: function (toggleGroupRestrictionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([toggleGroupRestrictionRequest_1], args_1, true), void 0, function (toggleGroupRestrictionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/GroupRestrictions/Toggle";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(toggleGroupRestrictionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.GroupRestrictionsApiAxiosParamCreator = GroupRestrictionsApiAxiosParamCreator;
/**
 * GroupRestrictionsApi - functional programming interface
 * @export
 */
var GroupRestrictionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GroupRestrictionsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {DeleteBulkGroupRestrictionRequest} [deleteBulkGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsDeleteBulkPost: function (deleteBulkGroupRestrictionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupRestrictionsDeleteBulkPost(deleteBulkGroupRestrictionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGetGet: function (page, pageLength, groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupRestrictionsGetGet(page, pageLength, groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {ToggleGroupRestrictionRequest} [toggleGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsTogglePost: function (toggleGroupRestrictionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupRestrictionsTogglePost(toggleGroupRestrictionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GroupRestrictionsApiFp = GroupRestrictionsApiFp;
/**
 * GroupRestrictionsApi - factory interface
 * @export
 */
var GroupRestrictionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GroupRestrictionsApiFp)(configuration);
    return {
        /**
         *
         * @param {DeleteBulkGroupRestrictionRequest} [deleteBulkGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsDeleteBulkPost: function (deleteBulkGroupRestrictionRequest, options) {
            return localVarFp.apiV1GroupRestrictionsDeleteBulkPost(deleteBulkGroupRestrictionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsGetGet: function (page, pageLength, groupId, options) {
            return localVarFp.apiV1GroupRestrictionsGetGet(page, pageLength, groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {ToggleGroupRestrictionRequest} [toggleGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupRestrictionsTogglePost: function (toggleGroupRestrictionRequest, options) {
            return localVarFp.apiV1GroupRestrictionsTogglePost(toggleGroupRestrictionRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GroupRestrictionsApiFactory = GroupRestrictionsApiFactory;
/**
 * GroupRestrictionsApi - object-oriented interface
 * @export
 * @class GroupRestrictionsApi
 * @extends {BaseAPI}
 */
var GroupRestrictionsApi = /** @class */ (function (_super) {
    __extends(GroupRestrictionsApi, _super);
    function GroupRestrictionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {DeleteBulkGroupRestrictionRequest} [deleteBulkGroupRestrictionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupRestrictionsApi
     */
    GroupRestrictionsApi.prototype.apiV1GroupRestrictionsDeleteBulkPost = function (deleteBulkGroupRestrictionRequest, options) {
        var _this = this;
        return (0, exports.GroupRestrictionsApiFp)(this.configuration).apiV1GroupRestrictionsDeleteBulkPost(deleteBulkGroupRestrictionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupRestrictionsApi
     */
    GroupRestrictionsApi.prototype.apiV1GroupRestrictionsGetGet = function (page, pageLength, groupId, options) {
        var _this = this;
        return (0, exports.GroupRestrictionsApiFp)(this.configuration).apiV1GroupRestrictionsGetGet(page, pageLength, groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {ToggleGroupRestrictionRequest} [toggleGroupRestrictionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupRestrictionsApi
     */
    GroupRestrictionsApi.prototype.apiV1GroupRestrictionsTogglePost = function (toggleGroupRestrictionRequest, options) {
        var _this = this;
        return (0, exports.GroupRestrictionsApiFp)(this.configuration).apiV1GroupRestrictionsTogglePost(toggleGroupRestrictionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GroupRestrictionsApi;
}(base_1.BaseAPI));
exports.GroupRestrictionsApi = GroupRestrictionsApi;
/**
 * GroupsApi - axios parameter creator
 * @export
 */
var GroupsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {DeleteBulkGroupRequest} [deleteBulkGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsDeleteBulkPost: function (deleteBulkGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteBulkGroupRequest_1], args_1, true), void 0, function (deleteBulkGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Groups/DeleteBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteBulkGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {boolean} [canManageVaults]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {GroupOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGet: function (page_1, pageLength_1, canManageVaults_1, employeeAccountId_1, searchQuery_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 7; _i < arguments.length; _i++) {
                args_1[_i - 7] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, canManageVaults_1, employeeAccountId_1, searchQuery_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (page, pageLength, canManageVaults, employeeAccountId, searchQuery, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/Groups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (canManageVaults !== undefined) {
                                localVarQueryParameter['CanManageVaults'] = canManageVaults;
                            }
                            if (employeeAccountId !== undefined) {
                                localVarQueryParameter['EmployeeAccountId'] = employeeAccountId;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} vaultId
         * @param {string} [searchQuery]
         * @param {GroupsByVaultIdOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGetByVaultIdGet: function (page_1, pageLength_1, vaultId_1, searchQuery_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, vaultId_1, searchQuery_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (page, pageLength, vaultId, searchQuery, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupsGetByVaultIdGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupsGetByVaultIdGet', 'pageLength', pageLength);
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupsGetByVaultIdGet', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Groups/GetByVaultId";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (vaultId !== undefined) {
                                localVarQueryParameter['VaultId'] = vaultId;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGroupIdGet: function (groupId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([groupId_1], args_1, true), void 0, function (groupId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'groupId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupsGroupIdGet', 'groupId', groupId);
                            localVarPath = "/api/v1/Groups/{groupId}"
                                .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGroupIdPatch: function (groupId_1, operation_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([groupId_1, operation_1], args_1, true), void 0, function (groupId, operation, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'groupId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1GroupsGroupIdPatch', 'groupId', groupId);
                            localVarPath = "/api/v1/Groups/{groupId}"
                                .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(operation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateGroupRequest} [createGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsPost: function (createGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createGroupRequest_1], args_1, true), void 0, function (createGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Groups";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.GroupsApiAxiosParamCreator = GroupsApiAxiosParamCreator;
/**
 * GroupsApi - functional programming interface
 * @export
 */
var GroupsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GroupsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {DeleteBulkGroupRequest} [deleteBulkGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsDeleteBulkPost: function (deleteBulkGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupsDeleteBulkPost(deleteBulkGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {boolean} [canManageVaults]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {GroupOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGet: function (page, pageLength, canManageVaults, employeeAccountId, searchQuery, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupsGet(page, pageLength, canManageVaults, employeeAccountId, searchQuery, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} vaultId
         * @param {string} [searchQuery]
         * @param {GroupsByVaultIdOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGetByVaultIdGet: function (page, pageLength, vaultId, searchQuery, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupsGetByVaultIdGet(page, pageLength, vaultId, searchQuery, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGroupIdGet: function (groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupsGroupIdGet(groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGroupIdPatch: function (groupId, operation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupsGroupIdPatch(groupId, operation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateGroupRequest} [createGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsPost: function (createGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1GroupsPost(createGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GroupsApiFp = GroupsApiFp;
/**
 * GroupsApi - factory interface
 * @export
 */
var GroupsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GroupsApiFp)(configuration);
    return {
        /**
         *
         * @param {DeleteBulkGroupRequest} [deleteBulkGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsDeleteBulkPost: function (deleteBulkGroupRequest, options) {
            return localVarFp.apiV1GroupsDeleteBulkPost(deleteBulkGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {boolean} [canManageVaults]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {GroupOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGet: function (page, pageLength, canManageVaults, employeeAccountId, searchQuery, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1GroupsGet(page, pageLength, canManageVaults, employeeAccountId, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} vaultId
         * @param {string} [searchQuery]
         * @param {GroupsByVaultIdOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGetByVaultIdGet: function (page, pageLength, vaultId, searchQuery, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1GroupsGetByVaultIdGet(page, pageLength, vaultId, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGroupIdGet: function (groupId, options) {
            return localVarFp.apiV1GroupsGroupIdGet(groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} groupId
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsGroupIdPatch: function (groupId, operation, options) {
            return localVarFp.apiV1GroupsGroupIdPatch(groupId, operation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateGroupRequest} [createGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1GroupsPost: function (createGroupRequest, options) {
            return localVarFp.apiV1GroupsPost(createGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GroupsApiFactory = GroupsApiFactory;
/**
 * GroupsApi - object-oriented interface
 * @export
 * @class GroupsApi
 * @extends {BaseAPI}
 */
var GroupsApi = /** @class */ (function (_super) {
    __extends(GroupsApi, _super);
    function GroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {DeleteBulkGroupRequest} [deleteBulkGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.apiV1GroupsDeleteBulkPost = function (deleteBulkGroupRequest, options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).apiV1GroupsDeleteBulkPost(deleteBulkGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {boolean} [canManageVaults]
     * @param {string} [employeeAccountId]
     * @param {string} [searchQuery]
     * @param {GroupOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.apiV1GroupsGet = function (page, pageLength, canManageVaults, employeeAccountId, searchQuery, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).apiV1GroupsGet(page, pageLength, canManageVaults, employeeAccountId, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} vaultId
     * @param {string} [searchQuery]
     * @param {GroupsByVaultIdOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.apiV1GroupsGetByVaultIdGet = function (page, pageLength, vaultId, searchQuery, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).apiV1GroupsGetByVaultIdGet(page, pageLength, vaultId, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.apiV1GroupsGroupIdGet = function (groupId, options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).apiV1GroupsGroupIdGet(groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} groupId
     * @param {Array<Operation>} [operation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.apiV1GroupsGroupIdPatch = function (groupId, operation, options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).apiV1GroupsGroupIdPatch(groupId, operation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateGroupRequest} [createGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.apiV1GroupsPost = function (createGroupRequest, options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).apiV1GroupsPost(createGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GroupsApi;
}(base_1.BaseAPI));
exports.GroupsApi = GroupsApi;
/**
 * IpGroupRestrictionsApi - axios parameter creator
 * @export
 */
var IpGroupRestrictionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} groupRestrictionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IpGroupRestrictionsGroupRestrictionIdGet: function (groupRestrictionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([groupRestrictionId_1], args_1, true), void 0, function (groupRestrictionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'groupRestrictionId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1IpGroupRestrictionsGroupRestrictionIdGet', 'groupRestrictionId', groupRestrictionId);
                            localVarPath = "/api/v1/IpGroupRestrictions/{groupRestrictionId}"
                                .replace("{".concat("groupRestrictionId", "}"), encodeURIComponent(String(groupRestrictionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupRestrictionId
         * @param {PatchIpGroupRestrictionRequest} [patchIpGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IpGroupRestrictionsGroupRestrictionIdPatch: function (groupRestrictionId_1, patchIpGroupRestrictionRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([groupRestrictionId_1, patchIpGroupRestrictionRequest_1], args_1, true), void 0, function (groupRestrictionId, patchIpGroupRestrictionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'groupRestrictionId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1IpGroupRestrictionsGroupRestrictionIdPatch', 'groupRestrictionId', groupRestrictionId);
                            localVarPath = "/api/v1/IpGroupRestrictions/{groupRestrictionId}"
                                .replace("{".concat("groupRestrictionId", "}"), encodeURIComponent(String(groupRestrictionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchIpGroupRestrictionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateIpGroupRestrictionRequest} [createIpGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IpGroupRestrictionsPost: function (createIpGroupRestrictionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createIpGroupRestrictionRequest_1], args_1, true), void 0, function (createIpGroupRestrictionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/IpGroupRestrictions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createIpGroupRestrictionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.IpGroupRestrictionsApiAxiosParamCreator = IpGroupRestrictionsApiAxiosParamCreator;
/**
 * IpGroupRestrictionsApi - functional programming interface
 * @export
 */
var IpGroupRestrictionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.IpGroupRestrictionsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} groupRestrictionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IpGroupRestrictionsGroupRestrictionIdGet: function (groupRestrictionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1IpGroupRestrictionsGroupRestrictionIdGet(groupRestrictionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupRestrictionId
         * @param {PatchIpGroupRestrictionRequest} [patchIpGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IpGroupRestrictionsGroupRestrictionIdPatch: function (groupRestrictionId, patchIpGroupRestrictionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1IpGroupRestrictionsGroupRestrictionIdPatch(groupRestrictionId, patchIpGroupRestrictionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateIpGroupRestrictionRequest} [createIpGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IpGroupRestrictionsPost: function (createIpGroupRestrictionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1IpGroupRestrictionsPost(createIpGroupRestrictionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.IpGroupRestrictionsApiFp = IpGroupRestrictionsApiFp;
/**
 * IpGroupRestrictionsApi - factory interface
 * @export
 */
var IpGroupRestrictionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.IpGroupRestrictionsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} groupRestrictionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IpGroupRestrictionsGroupRestrictionIdGet: function (groupRestrictionId, options) {
            return localVarFp.apiV1IpGroupRestrictionsGroupRestrictionIdGet(groupRestrictionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} groupRestrictionId
         * @param {PatchIpGroupRestrictionRequest} [patchIpGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IpGroupRestrictionsGroupRestrictionIdPatch: function (groupRestrictionId, patchIpGroupRestrictionRequest, options) {
            return localVarFp.apiV1IpGroupRestrictionsGroupRestrictionIdPatch(groupRestrictionId, patchIpGroupRestrictionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateIpGroupRestrictionRequest} [createIpGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1IpGroupRestrictionsPost: function (createIpGroupRestrictionRequest, options) {
            return localVarFp.apiV1IpGroupRestrictionsPost(createIpGroupRestrictionRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.IpGroupRestrictionsApiFactory = IpGroupRestrictionsApiFactory;
/**
 * IpGroupRestrictionsApi - object-oriented interface
 * @export
 * @class IpGroupRestrictionsApi
 * @extends {BaseAPI}
 */
var IpGroupRestrictionsApi = /** @class */ (function (_super) {
    __extends(IpGroupRestrictionsApi, _super);
    function IpGroupRestrictionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} groupRestrictionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IpGroupRestrictionsApi
     */
    IpGroupRestrictionsApi.prototype.apiV1IpGroupRestrictionsGroupRestrictionIdGet = function (groupRestrictionId, options) {
        var _this = this;
        return (0, exports.IpGroupRestrictionsApiFp)(this.configuration).apiV1IpGroupRestrictionsGroupRestrictionIdGet(groupRestrictionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} groupRestrictionId
     * @param {PatchIpGroupRestrictionRequest} [patchIpGroupRestrictionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IpGroupRestrictionsApi
     */
    IpGroupRestrictionsApi.prototype.apiV1IpGroupRestrictionsGroupRestrictionIdPatch = function (groupRestrictionId, patchIpGroupRestrictionRequest, options) {
        var _this = this;
        return (0, exports.IpGroupRestrictionsApiFp)(this.configuration).apiV1IpGroupRestrictionsGroupRestrictionIdPatch(groupRestrictionId, patchIpGroupRestrictionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateIpGroupRestrictionRequest} [createIpGroupRestrictionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IpGroupRestrictionsApi
     */
    IpGroupRestrictionsApi.prototype.apiV1IpGroupRestrictionsPost = function (createIpGroupRestrictionRequest, options) {
        var _this = this;
        return (0, exports.IpGroupRestrictionsApiFp)(this.configuration).apiV1IpGroupRestrictionsPost(createIpGroupRestrictionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IpGroupRestrictionsApi;
}(base_1.BaseAPI));
exports.IpGroupRestrictionsApi = IpGroupRestrictionsApi;
/**
 * MasterPasswordResetRequestsApi - axios parameter creator
 * @export
 */
var MasterPasswordResetRequestsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {BulkApproveMasterPasswordResetRequestsRequest} [bulkApproveMasterPasswordResetRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestsBulkApprovePost: function (bulkApproveMasterPasswordResetRequestsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bulkApproveMasterPasswordResetRequestsRequest_1], args_1, true), void 0, function (bulkApproveMasterPasswordResetRequestsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/MasterPasswordResetRequests/BulkApprove";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkApproveMasterPasswordResetRequestsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkRejectMasterPasswordResetRequestsRequest} [bulkRejectMasterPasswordResetRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestsBulkRejectPost: function (bulkRejectMasterPasswordResetRequestsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bulkRejectMasterPasswordResetRequestsRequest_1], args_1, true), void 0, function (bulkRejectMasterPasswordResetRequestsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/MasterPasswordResetRequests/BulkReject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkRejectMasterPasswordResetRequestsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {MasterPasswordResetRequestOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {string} [searchQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestsGet: function (page_1, pageLength_1, orderPropertyName_1, isDescending_1, searchQuery_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, orderPropertyName_1, isDescending_1, searchQuery_1], args_1, true), void 0, function (page, pageLength, orderPropertyName, isDescending, searchQuery, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1MasterPasswordResetRequestsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1MasterPasswordResetRequestsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/MasterPasswordResetRequests";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.MasterPasswordResetRequestsApiAxiosParamCreator = MasterPasswordResetRequestsApiAxiosParamCreator;
/**
 * MasterPasswordResetRequestsApi - functional programming interface
 * @export
 */
var MasterPasswordResetRequestsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MasterPasswordResetRequestsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {BulkApproveMasterPasswordResetRequestsRequest} [bulkApproveMasterPasswordResetRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestsBulkApprovePost: function (bulkApproveMasterPasswordResetRequestsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MasterPasswordResetRequestsBulkApprovePost(bulkApproveMasterPasswordResetRequestsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkRejectMasterPasswordResetRequestsRequest} [bulkRejectMasterPasswordResetRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestsBulkRejectPost: function (bulkRejectMasterPasswordResetRequestsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MasterPasswordResetRequestsBulkRejectPost(bulkRejectMasterPasswordResetRequestsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {MasterPasswordResetRequestOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {string} [searchQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestsGet: function (page, pageLength, orderPropertyName, isDescending, searchQuery, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MasterPasswordResetRequestsGet(page, pageLength, orderPropertyName, isDescending, searchQuery, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MasterPasswordResetRequestsApiFp = MasterPasswordResetRequestsApiFp;
/**
 * MasterPasswordResetRequestsApi - factory interface
 * @export
 */
var MasterPasswordResetRequestsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MasterPasswordResetRequestsApiFp)(configuration);
    return {
        /**
         *
         * @param {BulkApproveMasterPasswordResetRequestsRequest} [bulkApproveMasterPasswordResetRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestsBulkApprovePost: function (bulkApproveMasterPasswordResetRequestsRequest, options) {
            return localVarFp.apiV1MasterPasswordResetRequestsBulkApprovePost(bulkApproveMasterPasswordResetRequestsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {BulkRejectMasterPasswordResetRequestsRequest} [bulkRejectMasterPasswordResetRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestsBulkRejectPost: function (bulkRejectMasterPasswordResetRequestsRequest, options) {
            return localVarFp.apiV1MasterPasswordResetRequestsBulkRejectPost(bulkRejectMasterPasswordResetRequestsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {MasterPasswordResetRequestOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {string} [searchQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MasterPasswordResetRequestsGet: function (page, pageLength, orderPropertyName, isDescending, searchQuery, options) {
            return localVarFp.apiV1MasterPasswordResetRequestsGet(page, pageLength, orderPropertyName, isDescending, searchQuery, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MasterPasswordResetRequestsApiFactory = MasterPasswordResetRequestsApiFactory;
/**
 * MasterPasswordResetRequestsApi - object-oriented interface
 * @export
 * @class MasterPasswordResetRequestsApi
 * @extends {BaseAPI}
 */
var MasterPasswordResetRequestsApi = /** @class */ (function (_super) {
    __extends(MasterPasswordResetRequestsApi, _super);
    function MasterPasswordResetRequestsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {BulkApproveMasterPasswordResetRequestsRequest} [bulkApproveMasterPasswordResetRequestsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterPasswordResetRequestsApi
     */
    MasterPasswordResetRequestsApi.prototype.apiV1MasterPasswordResetRequestsBulkApprovePost = function (bulkApproveMasterPasswordResetRequestsRequest, options) {
        var _this = this;
        return (0, exports.MasterPasswordResetRequestsApiFp)(this.configuration).apiV1MasterPasswordResetRequestsBulkApprovePost(bulkApproveMasterPasswordResetRequestsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {BulkRejectMasterPasswordResetRequestsRequest} [bulkRejectMasterPasswordResetRequestsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterPasswordResetRequestsApi
     */
    MasterPasswordResetRequestsApi.prototype.apiV1MasterPasswordResetRequestsBulkRejectPost = function (bulkRejectMasterPasswordResetRequestsRequest, options) {
        var _this = this;
        return (0, exports.MasterPasswordResetRequestsApiFp)(this.configuration).apiV1MasterPasswordResetRequestsBulkRejectPost(bulkRejectMasterPasswordResetRequestsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {MasterPasswordResetRequestOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {string} [searchQuery]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterPasswordResetRequestsApi
     */
    MasterPasswordResetRequestsApi.prototype.apiV1MasterPasswordResetRequestsGet = function (page, pageLength, orderPropertyName, isDescending, searchQuery, options) {
        var _this = this;
        return (0, exports.MasterPasswordResetRequestsApiFp)(this.configuration).apiV1MasterPasswordResetRequestsGet(page, pageLength, orderPropertyName, isDescending, searchQuery, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MasterPasswordResetRequestsApi;
}(base_1.BaseAPI));
exports.MasterPasswordResetRequestsApi = MasterPasswordResetRequestsApi;
/**
 * MigrationApi - axios parameter creator
 * @export
 */
var MigrationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {BulkSendInviteEmailsRequest} [bulkSendInviteEmailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationBulkSendInviteEmailsPost: function (bulkSendInviteEmailsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bulkSendInviteEmailsRequest_1], args_1, true), void 0, function (bulkSendInviteEmailsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Migration/BulkSendInviteEmails";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkSendInviteEmailsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} organizationId
         * @param {string} masterPasswordHash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationCheckGet: function (organizationId_1, masterPasswordHash_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([organizationId_1, masterPasswordHash_1], args_1, true), void 0, function (organizationId, masterPasswordHash, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'organizationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1MigrationCheckGet', 'organizationId', organizationId);
                            // verify required parameter 'masterPasswordHash' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1MigrationCheckGet', 'masterPasswordHash', masterPasswordHash);
                            localVarPath = "/api/v1/Migration/Check";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (organizationId !== undefined) {
                                localVarQueryParameter['OrganizationId'] = organizationId;
                            }
                            if (masterPasswordHash !== undefined) {
                                localVarQueryParameter['MasterPasswordHash'] = masterPasswordHash;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [currentGenOrganizationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationCheckStatusGet: function (currentGenOrganizationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([currentGenOrganizationId_1], args_1, true), void 0, function (currentGenOrganizationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Migration/CheckStatus";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (currentGenOrganizationId !== undefined) {
                                localVarQueryParameter['CurrentGenOrganizationId'] = currentGenOrganizationId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationGetOrganizationsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Migration/GetOrganizations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {LoginRequest} [loginRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationLoginPost: function (loginRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([loginRequest_1], args_1, true), void 0, function (loginRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Migration/Login";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(loginRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {MigrateRequest} [migrateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationMigratePost: function (migrateRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([migrateRequest_1], args_1, true), void 0, function (migrateRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Migration/Migrate";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(migrateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshMigrationTokenRequest} [refreshMigrationTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationRefreshMigrationTokenPost: function (refreshMigrationTokenRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([refreshMigrationTokenRequest_1], args_1, true), void 0, function (refreshMigrationTokenRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Migration/RefreshMigrationToken";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refreshMigrationTokenRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.MigrationApiAxiosParamCreator = MigrationApiAxiosParamCreator;
/**
 * MigrationApi - functional programming interface
 * @export
 */
var MigrationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MigrationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {BulkSendInviteEmailsRequest} [bulkSendInviteEmailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationBulkSendInviteEmailsPost: function (bulkSendInviteEmailsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationBulkSendInviteEmailsPost(bulkSendInviteEmailsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} organizationId
         * @param {string} masterPasswordHash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationCheckGet: function (organizationId, masterPasswordHash, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationCheckGet(organizationId, masterPasswordHash, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [currentGenOrganizationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationCheckStatusGet: function (currentGenOrganizationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationCheckStatusGet(currentGenOrganizationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationGetOrganizationsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationGetOrganizationsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {LoginRequest} [loginRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationLoginPost: function (loginRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationLoginPost(loginRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {MigrateRequest} [migrateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationMigratePost: function (migrateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationMigratePost(migrateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshMigrationTokenRequest} [refreshMigrationTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationRefreshMigrationTokenPost: function (refreshMigrationTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1MigrationRefreshMigrationTokenPost(refreshMigrationTokenRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MigrationApiFp = MigrationApiFp;
/**
 * MigrationApi - factory interface
 * @export
 */
var MigrationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MigrationApiFp)(configuration);
    return {
        /**
         *
         * @param {BulkSendInviteEmailsRequest} [bulkSendInviteEmailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationBulkSendInviteEmailsPost: function (bulkSendInviteEmailsRequest, options) {
            return localVarFp.apiV1MigrationBulkSendInviteEmailsPost(bulkSendInviteEmailsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} organizationId
         * @param {string} masterPasswordHash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationCheckGet: function (organizationId, masterPasswordHash, options) {
            return localVarFp.apiV1MigrationCheckGet(organizationId, masterPasswordHash, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [currentGenOrganizationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationCheckStatusGet: function (currentGenOrganizationId, options) {
            return localVarFp.apiV1MigrationCheckStatusGet(currentGenOrganizationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationGetOrganizationsGet: function (options) {
            return localVarFp.apiV1MigrationGetOrganizationsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {LoginRequest} [loginRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationLoginPost: function (loginRequest, options) {
            return localVarFp.apiV1MigrationLoginPost(loginRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {MigrateRequest} [migrateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationMigratePost: function (migrateRequest, options) {
            return localVarFp.apiV1MigrationMigratePost(migrateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RefreshMigrationTokenRequest} [refreshMigrationTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1MigrationRefreshMigrationTokenPost: function (refreshMigrationTokenRequest, options) {
            return localVarFp.apiV1MigrationRefreshMigrationTokenPost(refreshMigrationTokenRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MigrationApiFactory = MigrationApiFactory;
/**
 * MigrationApi - object-oriented interface
 * @export
 * @class MigrationApi
 * @extends {BaseAPI}
 */
var MigrationApi = /** @class */ (function (_super) {
    __extends(MigrationApi, _super);
    function MigrationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {BulkSendInviteEmailsRequest} [bulkSendInviteEmailsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationBulkSendInviteEmailsPost = function (bulkSendInviteEmailsRequest, options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationBulkSendInviteEmailsPost(bulkSendInviteEmailsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} organizationId
     * @param {string} masterPasswordHash
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationCheckGet = function (organizationId, masterPasswordHash, options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationCheckGet(organizationId, masterPasswordHash, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [currentGenOrganizationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationCheckStatusGet = function (currentGenOrganizationId, options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationCheckStatusGet(currentGenOrganizationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationGetOrganizationsGet = function (options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationGetOrganizationsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {LoginRequest} [loginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationLoginPost = function (loginRequest, options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationLoginPost(loginRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {MigrateRequest} [migrateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationMigratePost = function (migrateRequest, options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationMigratePost(migrateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RefreshMigrationTokenRequest} [refreshMigrationTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationApi
     */
    MigrationApi.prototype.apiV1MigrationRefreshMigrationTokenPost = function (refreshMigrationTokenRequest, options) {
        var _this = this;
        return (0, exports.MigrationApiFp)(this.configuration).apiV1MigrationRefreshMigrationTokenPost(refreshMigrationTokenRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MigrationApi;
}(base_1.BaseAPI));
exports.MigrationApi = MigrationApi;
/**
 * OrganizationApi - axios parameter creator
 * @export
 */
var OrganizationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsCurrentGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Organizations/Current";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsPatch: function (operation_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([operation_1], args_1, true), void 0, function (operation, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Organizations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(operation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OrganizationApiAxiosParamCreator = OrganizationApiAxiosParamCreator;
/**
 * OrganizationApi - functional programming interface
 * @export
 */
var OrganizationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrganizationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsCurrentGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1OrganizationsCurrentGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsPatch: function (operation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1OrganizationsPatch(operation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OrganizationApiFp = OrganizationApiFp;
/**
 * OrganizationApi - factory interface
 * @export
 */
var OrganizationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrganizationApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsCurrentGet: function (options) {
            return localVarFp.apiV1OrganizationsCurrentGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<Operation>} [operation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationsPatch: function (operation, options) {
            return localVarFp.apiV1OrganizationsPatch(operation, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrganizationApiFactory = OrganizationApiFactory;
/**
 * OrganizationApi - object-oriented interface
 * @export
 * @class OrganizationApi
 * @extends {BaseAPI}
 */
var OrganizationApi = /** @class */ (function (_super) {
    __extends(OrganizationApi, _super);
    function OrganizationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.apiV1OrganizationsCurrentGet = function (options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).apiV1OrganizationsCurrentGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<Operation>} [operation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationApi
     */
    OrganizationApi.prototype.apiV1OrganizationsPatch = function (operation, options) {
        var _this = this;
        return (0, exports.OrganizationApiFp)(this.configuration).apiV1OrganizationsPatch(operation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrganizationApi;
}(base_1.BaseAPI));
exports.OrganizationApi = OrganizationApi;
/**
 * OrganizationKeysApi - axios parameter creator
 * @export
 */
var OrganizationKeysApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationKeysGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/OrganizationKeys";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OrganizationKeysApiAxiosParamCreator = OrganizationKeysApiAxiosParamCreator;
/**
 * OrganizationKeysApi - functional programming interface
 * @export
 */
var OrganizationKeysApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrganizationKeysApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationKeysGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1OrganizationKeysGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OrganizationKeysApiFp = OrganizationKeysApiFp;
/**
 * OrganizationKeysApi - factory interface
 * @export
 */
var OrganizationKeysApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrganizationKeysApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationKeysGet: function (options) {
            return localVarFp.apiV1OrganizationKeysGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrganizationKeysApiFactory = OrganizationKeysApiFactory;
/**
 * OrganizationKeysApi - object-oriented interface
 * @export
 * @class OrganizationKeysApi
 * @extends {BaseAPI}
 */
var OrganizationKeysApi = /** @class */ (function (_super) {
    __extends(OrganizationKeysApi, _super);
    function OrganizationKeysApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationKeysApi
     */
    OrganizationKeysApi.prototype.apiV1OrganizationKeysGet = function (options) {
        var _this = this;
        return (0, exports.OrganizationKeysApiFp)(this.configuration).apiV1OrganizationKeysGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrganizationKeysApi;
}(base_1.BaseAPI));
exports.OrganizationKeysApi = OrganizationKeysApi;
/**
 * OrganizationSettingsApi - axios parameter creator
 * @export
 */
var OrganizationSettingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetPartnerUsersAccessibleToCurrentOrganizationOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsPartnerSupportAccessGet: function (page_1, pageLength_1, searchQuery_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, searchQuery_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1OrganizationSettingsPartnerSupportAccessGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1OrganizationSettingsPartnerSupportAccessGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/OrganizationSettings/PartnerSupportAccess";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkRevokePartnerSupportAccessRequest} [bulkRevokePartnerSupportAccessRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsPartnerSupportAccessRevokePost: function (bulkRevokePartnerSupportAccessRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bulkRevokePartnerSupportAccessRequest_1], args_1, true), void 0, function (bulkRevokePartnerSupportAccessRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/OrganizationSettings/PartnerSupportAccessRevoke";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkRevokePartnerSupportAccessRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetPartnersAccessibleToCurrentOrganizationOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsPartnerSupportContractsGet: function (page_1, pageLength_1, searchQuery_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, searchQuery_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1OrganizationSettingsPartnerSupportContractsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1OrganizationSettingsPartnerSupportContractsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/OrganizationSettings/PartnerSupportContracts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OrganizationSettingsApiAxiosParamCreator = OrganizationSettingsApiAxiosParamCreator;
/**
 * OrganizationSettingsApi - functional programming interface
 * @export
 */
var OrganizationSettingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrganizationSettingsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetPartnerUsersAccessibleToCurrentOrganizationOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsPartnerSupportAccessGet: function (page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1OrganizationSettingsPartnerSupportAccessGet(page, pageLength, searchQuery, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkRevokePartnerSupportAccessRequest} [bulkRevokePartnerSupportAccessRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsPartnerSupportAccessRevokePost: function (bulkRevokePartnerSupportAccessRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1OrganizationSettingsPartnerSupportAccessRevokePost(bulkRevokePartnerSupportAccessRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetPartnersAccessibleToCurrentOrganizationOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsPartnerSupportContractsGet: function (page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1OrganizationSettingsPartnerSupportContractsGet(page, pageLength, searchQuery, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OrganizationSettingsApiFp = OrganizationSettingsApiFp;
/**
 * OrganizationSettingsApi - factory interface
 * @export
 */
var OrganizationSettingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrganizationSettingsApiFp)(configuration);
    return {
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetPartnerUsersAccessibleToCurrentOrganizationOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsPartnerSupportAccessGet: function (page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1OrganizationSettingsPartnerSupportAccessGet(page, pageLength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {BulkRevokePartnerSupportAccessRequest} [bulkRevokePartnerSupportAccessRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsPartnerSupportAccessRevokePost: function (bulkRevokePartnerSupportAccessRequest, options) {
            return localVarFp.apiV1OrganizationSettingsPartnerSupportAccessRevokePost(bulkRevokePartnerSupportAccessRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetPartnersAccessibleToCurrentOrganizationOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OrganizationSettingsPartnerSupportContractsGet: function (page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1OrganizationSettingsPartnerSupportContractsGet(page, pageLength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrganizationSettingsApiFactory = OrganizationSettingsApiFactory;
/**
 * OrganizationSettingsApi - object-oriented interface
 * @export
 * @class OrganizationSettingsApi
 * @extends {BaseAPI}
 */
var OrganizationSettingsApi = /** @class */ (function (_super) {
    __extends(OrganizationSettingsApi, _super);
    function OrganizationSettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} [searchQuery]
     * @param {GetPartnerUsersAccessibleToCurrentOrganizationOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationSettingsApi
     */
    OrganizationSettingsApi.prototype.apiV1OrganizationSettingsPartnerSupportAccessGet = function (page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.OrganizationSettingsApiFp)(this.configuration).apiV1OrganizationSettingsPartnerSupportAccessGet(page, pageLength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {BulkRevokePartnerSupportAccessRequest} [bulkRevokePartnerSupportAccessRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationSettingsApi
     */
    OrganizationSettingsApi.prototype.apiV1OrganizationSettingsPartnerSupportAccessRevokePost = function (bulkRevokePartnerSupportAccessRequest, options) {
        var _this = this;
        return (0, exports.OrganizationSettingsApiFp)(this.configuration).apiV1OrganizationSettingsPartnerSupportAccessRevokePost(bulkRevokePartnerSupportAccessRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} [searchQuery]
     * @param {GetPartnersAccessibleToCurrentOrganizationOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationSettingsApi
     */
    OrganizationSettingsApi.prototype.apiV1OrganizationSettingsPartnerSupportContractsGet = function (page, pageLength, searchQuery, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.OrganizationSettingsApiFp)(this.configuration).apiV1OrganizationSettingsPartnerSupportContractsGet(page, pageLength, searchQuery, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrganizationSettingsApi;
}(base_1.BaseAPI));
exports.OrganizationSettingsApi = OrganizationSettingsApi;
/**
 * PairingCodesApi - axios parameter creator
 * @export
 */
var PairingCodesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {CreatePairingCodeRequest} [createPairingCodeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PairingCodesCreatePairingCodePost: function (createPairingCodeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createPairingCodeRequest_1], args_1, true), void 0, function (createPairingCodeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PairingCodes/CreatePairingCode";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createPairingCodeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PairingCodesApiAxiosParamCreator = PairingCodesApiAxiosParamCreator;
/**
 * PairingCodesApi - functional programming interface
 * @export
 */
var PairingCodesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PairingCodesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {CreatePairingCodeRequest} [createPairingCodeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PairingCodesCreatePairingCodePost: function (createPairingCodeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PairingCodesCreatePairingCodePost(createPairingCodeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PairingCodesApiFp = PairingCodesApiFp;
/**
 * PairingCodesApi - factory interface
 * @export
 */
var PairingCodesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PairingCodesApiFp)(configuration);
    return {
        /**
         *
         * @param {CreatePairingCodeRequest} [createPairingCodeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PairingCodesCreatePairingCodePost: function (createPairingCodeRequest, options) {
            return localVarFp.apiV1PairingCodesCreatePairingCodePost(createPairingCodeRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PairingCodesApiFactory = PairingCodesApiFactory;
/**
 * PairingCodesApi - object-oriented interface
 * @export
 * @class PairingCodesApi
 * @extends {BaseAPI}
 */
var PairingCodesApi = /** @class */ (function (_super) {
    __extends(PairingCodesApi, _super);
    function PairingCodesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {CreatePairingCodeRequest} [createPairingCodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PairingCodesApi
     */
    PairingCodesApi.prototype.apiV1PairingCodesCreatePairingCodePost = function (createPairingCodeRequest, options) {
        var _this = this;
        return (0, exports.PairingCodesApiFp)(this.configuration).apiV1PairingCodesCreatePairingCodePost(createPairingCodeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PairingCodesApi;
}(base_1.BaseAPI));
exports.PairingCodesApi = PairingCodesApi;
/**
 * PartnerSupportRequestsApi - axios parameter creator
 * @export
 */
var PartnerSupportRequestsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {BulkApprovePartnerSupportRequestsRequest} [bulkApprovePartnerSupportRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerSupportRequestsBulkApprovePost: function (bulkApprovePartnerSupportRequestsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bulkApprovePartnerSupportRequestsRequest_1], args_1, true), void 0, function (bulkApprovePartnerSupportRequestsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PartnerSupportRequests/BulkApprove";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkApprovePartnerSupportRequestsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkRejectPartnerSupportRequestsRequest} [bulkRejectPartnerSupportRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerSupportRequestsBulkRejectPost: function (bulkRejectPartnerSupportRequestsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([bulkRejectPartnerSupportRequestsRequest_1], args_1, true), void 0, function (bulkRejectPartnerSupportRequestsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/PartnerSupportRequests/BulkReject";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkRejectPartnerSupportRequestsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetPartnerSupportRequestsRequestStatus} [statusFilter]
         * @param {GetPartnerSupportRequestsRequestOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerSupportRequestsGet: function (page_1, pageLength_1, searchQuery_1, statusFilter_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, searchQuery_1, statusFilter_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (page, pageLength, searchQuery, statusFilter, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1PartnerSupportRequestsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1PartnerSupportRequestsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/PartnerSupportRequests";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (statusFilter !== undefined) {
                                localVarQueryParameter['StatusFilter'] = statusFilter;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PartnerSupportRequestsApiAxiosParamCreator = PartnerSupportRequestsApiAxiosParamCreator;
/**
 * PartnerSupportRequestsApi - functional programming interface
 * @export
 */
var PartnerSupportRequestsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PartnerSupportRequestsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {BulkApprovePartnerSupportRequestsRequest} [bulkApprovePartnerSupportRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerSupportRequestsBulkApprovePost: function (bulkApprovePartnerSupportRequestsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PartnerSupportRequestsBulkApprovePost(bulkApprovePartnerSupportRequestsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {BulkRejectPartnerSupportRequestsRequest} [bulkRejectPartnerSupportRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerSupportRequestsBulkRejectPost: function (bulkRejectPartnerSupportRequestsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PartnerSupportRequestsBulkRejectPost(bulkRejectPartnerSupportRequestsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetPartnerSupportRequestsRequestStatus} [statusFilter]
         * @param {GetPartnerSupportRequestsRequestOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerSupportRequestsGet: function (page, pageLength, searchQuery, statusFilter, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1PartnerSupportRequestsGet(page, pageLength, searchQuery, statusFilter, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PartnerSupportRequestsApiFp = PartnerSupportRequestsApiFp;
/**
 * PartnerSupportRequestsApi - factory interface
 * @export
 */
var PartnerSupportRequestsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PartnerSupportRequestsApiFp)(configuration);
    return {
        /**
         *
         * @param {BulkApprovePartnerSupportRequestsRequest} [bulkApprovePartnerSupportRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerSupportRequestsBulkApprovePost: function (bulkApprovePartnerSupportRequestsRequest, options) {
            return localVarFp.apiV1PartnerSupportRequestsBulkApprovePost(bulkApprovePartnerSupportRequestsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {BulkRejectPartnerSupportRequestsRequest} [bulkRejectPartnerSupportRequestsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerSupportRequestsBulkRejectPost: function (bulkRejectPartnerSupportRequestsRequest, options) {
            return localVarFp.apiV1PartnerSupportRequestsBulkRejectPost(bulkRejectPartnerSupportRequestsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [searchQuery]
         * @param {GetPartnerSupportRequestsRequestStatus} [statusFilter]
         * @param {GetPartnerSupportRequestsRequestOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerSupportRequestsGet: function (page, pageLength, searchQuery, statusFilter, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1PartnerSupportRequestsGet(page, pageLength, searchQuery, statusFilter, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PartnerSupportRequestsApiFactory = PartnerSupportRequestsApiFactory;
/**
 * PartnerSupportRequestsApi - object-oriented interface
 * @export
 * @class PartnerSupportRequestsApi
 * @extends {BaseAPI}
 */
var PartnerSupportRequestsApi = /** @class */ (function (_super) {
    __extends(PartnerSupportRequestsApi, _super);
    function PartnerSupportRequestsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {BulkApprovePartnerSupportRequestsRequest} [bulkApprovePartnerSupportRequestsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerSupportRequestsApi
     */
    PartnerSupportRequestsApi.prototype.apiV1PartnerSupportRequestsBulkApprovePost = function (bulkApprovePartnerSupportRequestsRequest, options) {
        var _this = this;
        return (0, exports.PartnerSupportRequestsApiFp)(this.configuration).apiV1PartnerSupportRequestsBulkApprovePost(bulkApprovePartnerSupportRequestsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {BulkRejectPartnerSupportRequestsRequest} [bulkRejectPartnerSupportRequestsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerSupportRequestsApi
     */
    PartnerSupportRequestsApi.prototype.apiV1PartnerSupportRequestsBulkRejectPost = function (bulkRejectPartnerSupportRequestsRequest, options) {
        var _this = this;
        return (0, exports.PartnerSupportRequestsApiFp)(this.configuration).apiV1PartnerSupportRequestsBulkRejectPost(bulkRejectPartnerSupportRequestsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} [searchQuery]
     * @param {GetPartnerSupportRequestsRequestStatus} [statusFilter]
     * @param {GetPartnerSupportRequestsRequestOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerSupportRequestsApi
     */
    PartnerSupportRequestsApi.prototype.apiV1PartnerSupportRequestsGet = function (page, pageLength, searchQuery, statusFilter, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.PartnerSupportRequestsApiFp)(this.configuration).apiV1PartnerSupportRequestsGet(page, pageLength, searchQuery, statusFilter, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PartnerSupportRequestsApi;
}(base_1.BaseAPI));
exports.PartnerSupportRequestsApi = PartnerSupportRequestsApi;
/**
 * QueueApi - axios parameter creator
 * @export
 */
var QueueApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {CreateQueueMessageRequest} [createQueueMessageRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueCreatePost: function (createQueueMessageRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createQueueMessageRequest_1], args_1, true), void 0, function (createQueueMessageRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Queue/Create";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createQueueMessageRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} queueMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeleteQueueMessageQueueMessageIdDelete: function (queueMessageId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([queueMessageId_1], args_1, true), void 0, function (queueMessageId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'queueMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1QueueDeleteQueueMessageQueueMessageIdDelete', 'queueMessageId', queueMessageId);
                            localVarPath = "/api/v1/Queue/DeleteQueueMessage/{queueMessageId}"
                                .replace("{".concat("queueMessageId", "}"), encodeURIComponent(String(queueMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1QueueGetAdminEventTypesGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Queue/GetAdminEventTypes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} quantity
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetQueueMessagesGet: function (quantity_1, sessionId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([quantity_1, sessionId_1], args_1, true), void 0, function (quantity, sessionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'quantity' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1QueueGetQueueMessagesGet', 'quantity', quantity);
                            // verify required parameter 'sessionId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1QueueGetQueueMessagesGet', 'sessionId', sessionId);
                            localVarPath = "/api/v1/Queue/GetQueueMessages";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (quantity !== undefined) {
                                localVarQueryParameter['Quantity'] = quantity;
                            }
                            if (sessionId !== undefined) {
                                localVarQueryParameter['SessionId'] = sessionId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetUnprocessedInfoSessionIdGet: function (sessionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([sessionId_1], args_1, true), void 0, function (sessionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'sessionId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1QueueGetUnprocessedInfoSessionIdGet', 'sessionId', sessionId);
                            localVarPath = "/api/v1/Queue/GetUnprocessedInfo/{sessionId}"
                                .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RedirectEventsToTrustedPortalRequest} [redirectEventsToTrustedPortalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRedirectEventsToTrustedPortalPost: function (redirectEventsToTrustedPortalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([redirectEventsToTrustedPortalRequest_1], args_1, true), void 0, function (redirectEventsToTrustedPortalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Queue/RedirectEventsToTrustedPortal";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(redirectEventsToTrustedPortalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRestartTrustedPortalEventsPost: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Queue/RestartTrustedPortalEvents";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.QueueApiAxiosParamCreator = QueueApiAxiosParamCreator;
/**
 * QueueApi - functional programming interface
 * @export
 */
var QueueApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.QueueApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {CreateQueueMessageRequest} [createQueueMessageRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueCreatePost: function (createQueueMessageRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueCreatePost(createQueueMessageRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} queueMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeleteQueueMessageQueueMessageIdDelete: function (queueMessageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueDeleteQueueMessageQueueMessageIdDelete(queueMessageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1QueueGetAdminEventTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueGetAdminEventTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} quantity
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetQueueMessagesGet: function (quantity, sessionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueGetQueueMessagesGet(quantity, sessionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetUnprocessedInfoSessionIdGet: function (sessionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueGetUnprocessedInfoSessionIdGet(sessionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RedirectEventsToTrustedPortalRequest} [redirectEventsToTrustedPortalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRedirectEventsToTrustedPortalPost: function (redirectEventsToTrustedPortalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueRedirectEventsToTrustedPortalPost(redirectEventsToTrustedPortalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRestartTrustedPortalEventsPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1QueueRestartTrustedPortalEventsPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.QueueApiFp = QueueApiFp;
/**
 * QueueApi - factory interface
 * @export
 */
var QueueApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.QueueApiFp)(configuration);
    return {
        /**
         *
         * @param {CreateQueueMessageRequest} [createQueueMessageRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueCreatePost: function (createQueueMessageRequest, options) {
            return localVarFp.apiV1QueueCreatePost(createQueueMessageRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} queueMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueDeleteQueueMessageQueueMessageIdDelete: function (queueMessageId, options) {
            return localVarFp.apiV1QueueDeleteQueueMessageQueueMessageIdDelete(queueMessageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1QueueGetAdminEventTypesGet: function (options) {
            return localVarFp.apiV1QueueGetAdminEventTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} quantity
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetQueueMessagesGet: function (quantity, sessionId, options) {
            return localVarFp.apiV1QueueGetQueueMessagesGet(quantity, sessionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueGetUnprocessedInfoSessionIdGet: function (sessionId, options) {
            return localVarFp.apiV1QueueGetUnprocessedInfoSessionIdGet(sessionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RedirectEventsToTrustedPortalRequest} [redirectEventsToTrustedPortalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRedirectEventsToTrustedPortalPost: function (redirectEventsToTrustedPortalRequest, options) {
            return localVarFp.apiV1QueueRedirectEventsToTrustedPortalPost(redirectEventsToTrustedPortalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1QueueRestartTrustedPortalEventsPost: function (options) {
            return localVarFp.apiV1QueueRestartTrustedPortalEventsPost(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.QueueApiFactory = QueueApiFactory;
/**
 * QueueApi - object-oriented interface
 * @export
 * @class QueueApi
 * @extends {BaseAPI}
 */
var QueueApi = /** @class */ (function (_super) {
    __extends(QueueApi, _super);
    function QueueApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {CreateQueueMessageRequest} [createQueueMessageRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueCreatePost = function (createQueueMessageRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueCreatePost(createQueueMessageRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} queueMessageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueDeleteQueueMessageQueueMessageIdDelete = function (queueMessageId, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueDeleteQueueMessageQueueMessageIdDelete(queueMessageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueGetAdminEventTypesGet = function (options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueGetAdminEventTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} quantity
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueGetQueueMessagesGet = function (quantity, sessionId, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueGetQueueMessagesGet(quantity, sessionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueGetUnprocessedInfoSessionIdGet = function (sessionId, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueGetUnprocessedInfoSessionIdGet(sessionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RedirectEventsToTrustedPortalRequest} [redirectEventsToTrustedPortalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueRedirectEventsToTrustedPortalPost = function (redirectEventsToTrustedPortalRequest, options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueRedirectEventsToTrustedPortalPost(redirectEventsToTrustedPortalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueueApi
     */
    QueueApi.prototype.apiV1QueueRestartTrustedPortalEventsPost = function (options) {
        var _this = this;
        return (0, exports.QueueApiFp)(this.configuration).apiV1QueueRestartTrustedPortalEventsPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return QueueApi;
}(base_1.BaseAPI));
exports.QueueApi = QueueApi;
/**
 * ScimSettingsApi - axios parameter creator
 * @export
 */
var ScimSettingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ScimSettingsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/ScimSettings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateScimSettingsRequest} [updateScimSettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ScimSettingsPut: function (updateScimSettingsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updateScimSettingsRequest_1], args_1, true), void 0, function (updateScimSettingsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/ScimSettings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateScimSettingsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ScimSettingsApiAxiosParamCreator = ScimSettingsApiAxiosParamCreator;
/**
 * ScimSettingsApi - functional programming interface
 * @export
 */
var ScimSettingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ScimSettingsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ScimSettingsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1ScimSettingsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateScimSettingsRequest} [updateScimSettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ScimSettingsPut: function (updateScimSettingsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1ScimSettingsPut(updateScimSettingsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ScimSettingsApiFp = ScimSettingsApiFp;
/**
 * ScimSettingsApi - factory interface
 * @export
 */
var ScimSettingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ScimSettingsApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ScimSettingsGet: function (options) {
            return localVarFp.apiV1ScimSettingsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UpdateScimSettingsRequest} [updateScimSettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ScimSettingsPut: function (updateScimSettingsRequest, options) {
            return localVarFp.apiV1ScimSettingsPut(updateScimSettingsRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ScimSettingsApiFactory = ScimSettingsApiFactory;
/**
 * ScimSettingsApi - object-oriented interface
 * @export
 * @class ScimSettingsApi
 * @extends {BaseAPI}
 */
var ScimSettingsApi = /** @class */ (function (_super) {
    __extends(ScimSettingsApi, _super);
    function ScimSettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScimSettingsApi
     */
    ScimSettingsApi.prototype.apiV1ScimSettingsGet = function (options) {
        var _this = this;
        return (0, exports.ScimSettingsApiFp)(this.configuration).apiV1ScimSettingsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UpdateScimSettingsRequest} [updateScimSettingsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScimSettingsApi
     */
    ScimSettingsApi.prototype.apiV1ScimSettingsPut = function (updateScimSettingsRequest, options) {
        var _this = this;
        return (0, exports.ScimSettingsApiFp)(this.configuration).apiV1ScimSettingsPut(updateScimSettingsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ScimSettingsApi;
}(base_1.BaseAPI));
exports.ScimSettingsApi = ScimSettingsApi;
/**
 * SecuritySettingsApi - axios parameter creator
 * @export
 */
var SecuritySettingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SecuritySettingsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/SecuritySettings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateSecuritySettingsRequest} [updateSecuritySettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SecuritySettingsPut: function (updateSecuritySettingsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updateSecuritySettingsRequest_1], args_1, true), void 0, function (updateSecuritySettingsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/SecuritySettings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSecuritySettingsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SecuritySettingsApiAxiosParamCreator = SecuritySettingsApiAxiosParamCreator;
/**
 * SecuritySettingsApi - functional programming interface
 * @export
 */
var SecuritySettingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SecuritySettingsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SecuritySettingsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1SecuritySettingsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateSecuritySettingsRequest} [updateSecuritySettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SecuritySettingsPut: function (updateSecuritySettingsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1SecuritySettingsPut(updateSecuritySettingsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SecuritySettingsApiFp = SecuritySettingsApiFp;
/**
 * SecuritySettingsApi - factory interface
 * @export
 */
var SecuritySettingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SecuritySettingsApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SecuritySettingsGet: function (options) {
            return localVarFp.apiV1SecuritySettingsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UpdateSecuritySettingsRequest} [updateSecuritySettingsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SecuritySettingsPut: function (updateSecuritySettingsRequest, options) {
            return localVarFp.apiV1SecuritySettingsPut(updateSecuritySettingsRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SecuritySettingsApiFactory = SecuritySettingsApiFactory;
/**
 * SecuritySettingsApi - object-oriented interface
 * @export
 * @class SecuritySettingsApi
 * @extends {BaseAPI}
 */
var SecuritySettingsApi = /** @class */ (function (_super) {
    __extends(SecuritySettingsApi, _super);
    function SecuritySettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecuritySettingsApi
     */
    SecuritySettingsApi.prototype.apiV1SecuritySettingsGet = function (options) {
        var _this = this;
        return (0, exports.SecuritySettingsApiFp)(this.configuration).apiV1SecuritySettingsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UpdateSecuritySettingsRequest} [updateSecuritySettingsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecuritySettingsApi
     */
    SecuritySettingsApi.prototype.apiV1SecuritySettingsPut = function (updateSecuritySettingsRequest, options) {
        var _this = this;
        return (0, exports.SecuritySettingsApiFp)(this.configuration).apiV1SecuritySettingsPut(updateSecuritySettingsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SecuritySettingsApi;
}(base_1.BaseAPI));
exports.SecuritySettingsApi = SecuritySettingsApi;
/**
 * SupportedUILanguagesApi - axios parameter creator
 * @export
 */
var SupportedUILanguagesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupportedUILanguagesGetAllGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/SupportedUILanguages/GetAll";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupportedUILanguagesApiAxiosParamCreator = SupportedUILanguagesApiAxiosParamCreator;
/**
 * SupportedUILanguagesApi - functional programming interface
 * @export
 */
var SupportedUILanguagesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupportedUILanguagesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupportedUILanguagesGetAllGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1SupportedUILanguagesGetAllGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SupportedUILanguagesApiFp = SupportedUILanguagesApiFp;
/**
 * SupportedUILanguagesApi - factory interface
 * @export
 */
var SupportedUILanguagesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupportedUILanguagesApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupportedUILanguagesGetAllGet: function (options) {
            return localVarFp.apiV1SupportedUILanguagesGetAllGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupportedUILanguagesApiFactory = SupportedUILanguagesApiFactory;
/**
 * SupportedUILanguagesApi - object-oriented interface
 * @export
 * @class SupportedUILanguagesApi
 * @extends {BaseAPI}
 */
var SupportedUILanguagesApi = /** @class */ (function (_super) {
    __extends(SupportedUILanguagesApi, _super);
    function SupportedUILanguagesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportedUILanguagesApi
     */
    SupportedUILanguagesApi.prototype.apiV1SupportedUILanguagesGetAllGet = function (options) {
        var _this = this;
        return (0, exports.SupportedUILanguagesApiFp)(this.configuration).apiV1SupportedUILanguagesGetAllGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupportedUILanguagesApi;
}(base_1.BaseAPI));
exports.SupportedUILanguagesApi = SupportedUILanguagesApi;
/**
 * SupporterApi - axios parameter creator
 * @export
 */
var SupporterApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {CreateTrustedPortalRequest} [createTrustedPortalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterCreateTrustedPortalPost: function (createTrustedPortalRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createTrustedPortalRequest_1], args_1, true), void 0, function (createTrustedPortalRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Supporter/CreateTrustedPortal";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTrustedPortalRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterGetMobileTokensSessionIdGet: function (sessionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([sessionId_1], args_1, true), void 0, function (sessionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'sessionId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1SupporterGetMobileTokensSessionIdGet', 'sessionId', sessionId);
                            localVarPath = "/api/v1/Supporter/GetMobileTokens/{sessionId}"
                                .replace("{".concat("sessionId", "}"), encodeURIComponent(String(sessionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {PairSupporterRequest} [pairSupporterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterPairSupporterPost: function (pairSupporterRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([pairSupporterRequest_1], args_1, true), void 0, function (pairSupporterRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Supporter/PairSupporter";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pairSupporterRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterPartnerKeysGet: function (token_1, organizationId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([token_1, organizationId_1], args_1, true), void 0, function (token, organizationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'token' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1SupporterPartnerKeysGet', 'token', token);
                            // verify required parameter 'organizationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1SupporterPartnerKeysGet', 'organizationId', organizationId);
                            localVarPath = "/api/v1/Supporter/PartnerKeys";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (token !== undefined) {
                                localVarQueryParameter['Token'] = token;
                            }
                            if (organizationId !== undefined) {
                                localVarQueryParameter['OrganizationId'] = organizationId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupporterApiAxiosParamCreator = SupporterApiAxiosParamCreator;
/**
 * SupporterApi - functional programming interface
 * @export
 */
var SupporterApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupporterApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {CreateTrustedPortalRequest} [createTrustedPortalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterCreateTrustedPortalPost: function (createTrustedPortalRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1SupporterCreateTrustedPortalPost(createTrustedPortalRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterGetMobileTokensSessionIdGet: function (sessionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1SupporterGetMobileTokensSessionIdGet(sessionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {PairSupporterRequest} [pairSupporterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterPairSupporterPost: function (pairSupporterRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1SupporterPairSupporterPost(pairSupporterRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} token
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterPartnerKeysGet: function (token, organizationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1SupporterPartnerKeysGet(token, organizationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SupporterApiFp = SupporterApiFp;
/**
 * SupporterApi - factory interface
 * @export
 */
var SupporterApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupporterApiFp)(configuration);
    return {
        /**
         *
         * @param {CreateTrustedPortalRequest} [createTrustedPortalRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterCreateTrustedPortalPost: function (createTrustedPortalRequest, options) {
            return localVarFp.apiV1SupporterCreateTrustedPortalPost(createTrustedPortalRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} sessionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterGetMobileTokensSessionIdGet: function (sessionId, options) {
            return localVarFp.apiV1SupporterGetMobileTokensSessionIdGet(sessionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {PairSupporterRequest} [pairSupporterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterPairSupporterPost: function (pairSupporterRequest, options) {
            return localVarFp.apiV1SupporterPairSupporterPost(pairSupporterRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} token
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SupporterPartnerKeysGet: function (token, organizationId, options) {
            return localVarFp.apiV1SupporterPartnerKeysGet(token, organizationId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupporterApiFactory = SupporterApiFactory;
/**
 * SupporterApi - object-oriented interface
 * @export
 * @class SupporterApi
 * @extends {BaseAPI}
 */
var SupporterApi = /** @class */ (function (_super) {
    __extends(SupporterApi, _super);
    function SupporterApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {CreateTrustedPortalRequest} [createTrustedPortalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupporterApi
     */
    SupporterApi.prototype.apiV1SupporterCreateTrustedPortalPost = function (createTrustedPortalRequest, options) {
        var _this = this;
        return (0, exports.SupporterApiFp)(this.configuration).apiV1SupporterCreateTrustedPortalPost(createTrustedPortalRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupporterApi
     */
    SupporterApi.prototype.apiV1SupporterGetMobileTokensSessionIdGet = function (sessionId, options) {
        var _this = this;
        return (0, exports.SupporterApiFp)(this.configuration).apiV1SupporterGetMobileTokensSessionIdGet(sessionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PairSupporterRequest} [pairSupporterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupporterApi
     */
    SupporterApi.prototype.apiV1SupporterPairSupporterPost = function (pairSupporterRequest, options) {
        var _this = this;
        return (0, exports.SupporterApiFp)(this.configuration).apiV1SupporterPairSupporterPost(pairSupporterRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} token
     * @param {string} organizationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupporterApi
     */
    SupporterApi.prototype.apiV1SupporterPartnerKeysGet = function (token, organizationId, options) {
        var _this = this;
        return (0, exports.SupporterApiFp)(this.configuration).apiV1SupporterPartnerKeysGet(token, organizationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupporterApi;
}(base_1.BaseAPI));
exports.SupporterApi = SupporterApi;
/**
 * TimeOfDayGroupRestrictionsApi - axios parameter creator
 * @export
 */
var TimeOfDayGroupRestrictionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} groupRestrictionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdGet: function (groupRestrictionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([groupRestrictionId_1], args_1, true), void 0, function (groupRestrictionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'groupRestrictionId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdGet', 'groupRestrictionId', groupRestrictionId);
                            localVarPath = "/api/v1/TimeOfDayGroupRestrictions/{groupRestrictionId}"
                                .replace("{".concat("groupRestrictionId", "}"), encodeURIComponent(String(groupRestrictionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupRestrictionId
         * @param {PatchTimeOfDayGroupRestrictionRequest} [patchTimeOfDayGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdPatch: function (groupRestrictionId_1, patchTimeOfDayGroupRestrictionRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([groupRestrictionId_1, patchTimeOfDayGroupRestrictionRequest_1], args_1, true), void 0, function (groupRestrictionId, patchTimeOfDayGroupRestrictionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'groupRestrictionId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdPatch', 'groupRestrictionId', groupRestrictionId);
                            localVarPath = "/api/v1/TimeOfDayGroupRestrictions/{groupRestrictionId}"
                                .replace("{".concat("groupRestrictionId", "}"), encodeURIComponent(String(groupRestrictionId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchTimeOfDayGroupRestrictionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateTimeOfDayGroupRestrictionRequest} [createTimeOfDayGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeOfDayGroupRestrictionsPost: function (createTimeOfDayGroupRestrictionRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createTimeOfDayGroupRestrictionRequest_1], args_1, true), void 0, function (createTimeOfDayGroupRestrictionRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/TimeOfDayGroupRestrictions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTimeOfDayGroupRestrictionRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TimeOfDayGroupRestrictionsApiAxiosParamCreator = TimeOfDayGroupRestrictionsApiAxiosParamCreator;
/**
 * TimeOfDayGroupRestrictionsApi - functional programming interface
 * @export
 */
var TimeOfDayGroupRestrictionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TimeOfDayGroupRestrictionsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} groupRestrictionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdGet: function (groupRestrictionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdGet(groupRestrictionId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} groupRestrictionId
         * @param {PatchTimeOfDayGroupRestrictionRequest} [patchTimeOfDayGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdPatch: function (groupRestrictionId, patchTimeOfDayGroupRestrictionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdPatch(groupRestrictionId, patchTimeOfDayGroupRestrictionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateTimeOfDayGroupRestrictionRequest} [createTimeOfDayGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeOfDayGroupRestrictionsPost: function (createTimeOfDayGroupRestrictionRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TimeOfDayGroupRestrictionsPost(createTimeOfDayGroupRestrictionRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TimeOfDayGroupRestrictionsApiFp = TimeOfDayGroupRestrictionsApiFp;
/**
 * TimeOfDayGroupRestrictionsApi - factory interface
 * @export
 */
var TimeOfDayGroupRestrictionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TimeOfDayGroupRestrictionsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} groupRestrictionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdGet: function (groupRestrictionId, options) {
            return localVarFp.apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdGet(groupRestrictionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} groupRestrictionId
         * @param {PatchTimeOfDayGroupRestrictionRequest} [patchTimeOfDayGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdPatch: function (groupRestrictionId, patchTimeOfDayGroupRestrictionRequest, options) {
            return localVarFp.apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdPatch(groupRestrictionId, patchTimeOfDayGroupRestrictionRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateTimeOfDayGroupRestrictionRequest} [createTimeOfDayGroupRestrictionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TimeOfDayGroupRestrictionsPost: function (createTimeOfDayGroupRestrictionRequest, options) {
            return localVarFp.apiV1TimeOfDayGroupRestrictionsPost(createTimeOfDayGroupRestrictionRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TimeOfDayGroupRestrictionsApiFactory = TimeOfDayGroupRestrictionsApiFactory;
/**
 * TimeOfDayGroupRestrictionsApi - object-oriented interface
 * @export
 * @class TimeOfDayGroupRestrictionsApi
 * @extends {BaseAPI}
 */
var TimeOfDayGroupRestrictionsApi = /** @class */ (function (_super) {
    __extends(TimeOfDayGroupRestrictionsApi, _super);
    function TimeOfDayGroupRestrictionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} groupRestrictionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeOfDayGroupRestrictionsApi
     */
    TimeOfDayGroupRestrictionsApi.prototype.apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdGet = function (groupRestrictionId, options) {
        var _this = this;
        return (0, exports.TimeOfDayGroupRestrictionsApiFp)(this.configuration).apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdGet(groupRestrictionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} groupRestrictionId
     * @param {PatchTimeOfDayGroupRestrictionRequest} [patchTimeOfDayGroupRestrictionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeOfDayGroupRestrictionsApi
     */
    TimeOfDayGroupRestrictionsApi.prototype.apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdPatch = function (groupRestrictionId, patchTimeOfDayGroupRestrictionRequest, options) {
        var _this = this;
        return (0, exports.TimeOfDayGroupRestrictionsApiFp)(this.configuration).apiV1TimeOfDayGroupRestrictionsGroupRestrictionIdPatch(groupRestrictionId, patchTimeOfDayGroupRestrictionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateTimeOfDayGroupRestrictionRequest} [createTimeOfDayGroupRestrictionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeOfDayGroupRestrictionsApi
     */
    TimeOfDayGroupRestrictionsApi.prototype.apiV1TimeOfDayGroupRestrictionsPost = function (createTimeOfDayGroupRestrictionRequest, options) {
        var _this = this;
        return (0, exports.TimeOfDayGroupRestrictionsApiFp)(this.configuration).apiV1TimeOfDayGroupRestrictionsPost(createTimeOfDayGroupRestrictionRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TimeOfDayGroupRestrictionsApi;
}(base_1.BaseAPI));
exports.TimeOfDayGroupRestrictionsApi = TimeOfDayGroupRestrictionsApi;
/**
 * TrustedActionsApi - axios parameter creator
 * @export
 */
var TrustedActionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {TrustedActionType} trustedActionType
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionsCompanionApplicationIdTrustedActionTypeOrganizationIdDelete: function (companionApplicationId_1, trustedActionType_1, organizationId_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([companionApplicationId_1, trustedActionType_1, organizationId_1], args_1, true), void 0, function (companionApplicationId, trustedActionType, organizationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companionApplicationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1TrustedActionsCompanionApplicationIdTrustedActionTypeOrganizationIdDelete', 'companionApplicationId', companionApplicationId);
                            // verify required parameter 'trustedActionType' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1TrustedActionsCompanionApplicationIdTrustedActionTypeOrganizationIdDelete', 'trustedActionType', trustedActionType);
                            // verify required parameter 'organizationId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1TrustedActionsCompanionApplicationIdTrustedActionTypeOrganizationIdDelete', 'organizationId', organizationId);
                            localVarPath = "/api/v1/TrustedActions/{companionApplicationId}/{trustedActionType}/{organizationId}"
                                .replace("{".concat("companionApplicationId", "}"), encodeURIComponent(String(companionApplicationId)))
                                .replace("{".concat("trustedActionType", "}"), encodeURIComponent(String(trustedActionType)))
                                .replace("{".concat("organizationId", "}"), encodeURIComponent(String(organizationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionsGetAllGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/TrustedActions/GetAll";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TrustedActionsApiAxiosParamCreator = TrustedActionsApiAxiosParamCreator;
/**
 * TrustedActionsApi - functional programming interface
 * @export
 */
var TrustedActionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TrustedActionsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {TrustedActionType} trustedActionType
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionsCompanionApplicationIdTrustedActionTypeOrganizationIdDelete: function (companionApplicationId, trustedActionType, organizationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TrustedActionsCompanionApplicationIdTrustedActionTypeOrganizationIdDelete(companionApplicationId, trustedActionType, organizationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionsGetAllGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1TrustedActionsGetAllGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TrustedActionsApiFp = TrustedActionsApiFp;
/**
 * TrustedActionsApi - factory interface
 * @export
 */
var TrustedActionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TrustedActionsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} companionApplicationId
         * @param {TrustedActionType} trustedActionType
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionsCompanionApplicationIdTrustedActionTypeOrganizationIdDelete: function (companionApplicationId, trustedActionType, organizationId, options) {
            return localVarFp.apiV1TrustedActionsCompanionApplicationIdTrustedActionTypeOrganizationIdDelete(companionApplicationId, trustedActionType, organizationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TrustedActionsGetAllGet: function (options) {
            return localVarFp.apiV1TrustedActionsGetAllGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TrustedActionsApiFactory = TrustedActionsApiFactory;
/**
 * TrustedActionsApi - object-oriented interface
 * @export
 * @class TrustedActionsApi
 * @extends {BaseAPI}
 */
var TrustedActionsApi = /** @class */ (function (_super) {
    __extends(TrustedActionsApi, _super);
    function TrustedActionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} companionApplicationId
     * @param {TrustedActionType} trustedActionType
     * @param {string} organizationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustedActionsApi
     */
    TrustedActionsApi.prototype.apiV1TrustedActionsCompanionApplicationIdTrustedActionTypeOrganizationIdDelete = function (companionApplicationId, trustedActionType, organizationId, options) {
        var _this = this;
        return (0, exports.TrustedActionsApiFp)(this.configuration).apiV1TrustedActionsCompanionApplicationIdTrustedActionTypeOrganizationIdDelete(companionApplicationId, trustedActionType, organizationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrustedActionsApi
     */
    TrustedActionsApi.prototype.apiV1TrustedActionsGetAllGet = function (options) {
        var _this = this;
        return (0, exports.TrustedActionsApiFp)(this.configuration).apiV1TrustedActionsGetAllGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TrustedActionsApi;
}(base_1.BaseAPI));
exports.TrustedActionsApi = TrustedActionsApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
var UserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserCurrentUserProfileGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/CurrentUserProfile";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {PutUserProfileRequest} [putUserProfileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserEditCurrentUserProfilePut: function (putUserProfileRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([putUserProfileRequest_1], args_1, true), void 0, function (putUserProfileRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/EditCurrentUserProfile";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(putUserProfileRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserLogoutPost: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/Logout";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRefreshTokenPost: function (refreshTokenRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([refreshTokenRequest_1], args_1, true), void 0, function (refreshTokenRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/RefreshToken";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refreshTokenRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateUserNameRequest} [updateUserNameRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUpdateCurrentUserProfilePut: function (updateUserNameRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updateUserNameRequest_1], args_1, true), void 0, function (updateUserNameRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/UpdateCurrentUserProfile";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateUserNameRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateUserLanguageRequest} [updateUserLanguageRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUpdateUserLanguagePut: function (updateUserLanguageRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([updateUserLanguageRequest_1], args_1, true), void 0, function (updateUserLanguageRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/User/UpdateUserLanguage";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateUserLanguageRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
var UserApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserCurrentUserProfileGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserCurrentUserProfileGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {PutUserProfileRequest} [putUserProfileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserEditCurrentUserProfilePut: function (putUserProfileRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserEditCurrentUserProfilePut(putUserProfileRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserLogoutPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserLogoutPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRefreshTokenPost: function (refreshTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserRefreshTokenPost(refreshTokenRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateUserNameRequest} [updateUserNameRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUpdateCurrentUserProfilePut: function (updateUserNameRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserUpdateCurrentUserProfilePut(updateUserNameRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {UpdateUserLanguageRequest} [updateUserLanguageRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUpdateUserLanguagePut: function (updateUserLanguageRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1UserUpdateUserLanguagePut(updateUserLanguageRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
var UserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UserApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserCurrentUserProfileGet: function (options) {
            return localVarFp.apiV1UserCurrentUserProfileGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {PutUserProfileRequest} [putUserProfileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserEditCurrentUserProfilePut: function (putUserProfileRequest, options) {
            return localVarFp.apiV1UserEditCurrentUserProfilePut(putUserProfileRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserLogoutPost: function (options) {
            return localVarFp.apiV1UserLogoutPost(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {RefreshTokenRequest} [refreshTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserRefreshTokenPost: function (refreshTokenRequest, options) {
            return localVarFp.apiV1UserRefreshTokenPost(refreshTokenRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UpdateUserNameRequest} [updateUserNameRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUpdateCurrentUserProfilePut: function (updateUserNameRequest, options) {
            return localVarFp.apiV1UserUpdateCurrentUserProfilePut(updateUserNameRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {UpdateUserLanguageRequest} [updateUserLanguageRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserUpdateUserLanguagePut: function (updateUserLanguageRequest, options) {
            return localVarFp.apiV1UserUpdateUserLanguagePut(updateUserLanguageRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserCurrentUserProfileGet = function (options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserCurrentUserProfileGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {PutUserProfileRequest} [putUserProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserEditCurrentUserProfilePut = function (putUserProfileRequest, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserEditCurrentUserProfilePut(putUserProfileRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserLogoutPost = function (options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserLogoutPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {RefreshTokenRequest} [refreshTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserRefreshTokenPost = function (refreshTokenRequest, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserRefreshTokenPost(refreshTokenRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UpdateUserNameRequest} [updateUserNameRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserUpdateCurrentUserProfilePut = function (updateUserNameRequest, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserUpdateCurrentUserProfilePut(updateUserNameRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {UpdateUserLanguageRequest} [updateUserLanguageRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.apiV1UserUpdateUserLanguagePut = function (updateUserLanguageRequest, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).apiV1UserUpdateUserLanguagePut(updateUserLanguageRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserApi;
}(base_1.BaseAPI));
exports.UserApi = UserApi;
/**
 * VaultsApi - axios parameter creator
 * @export
 */
var VaultsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {CreateVaultCreditCardRequest} [createVaultCreditCardRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsCreateVaultCreditCardPost: function (createVaultCreditCardRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultCreditCardRequest_1], args_1, true), void 0, function (createVaultCreditCardRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/CreateVaultCreditCard";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultCreditCardRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultPasswordRequest} [createVaultPasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsCreateVaultPasswordPost: function (createVaultPasswordRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultPasswordRequest_1], args_1, true), void 0, function (createVaultPasswordRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/CreateVaultPassword";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultPasswordRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultSecureNoteRequest} [createVaultSecureNoteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsCreateVaultSecureNotePost: function (createVaultSecureNoteRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultSecureNoteRequest_1], args_1, true), void 0, function (createVaultSecureNoteRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/CreateVaultSecureNote";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultSecureNoteRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkVaultsRequest} [deleteBulkVaultsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsDeleteBulkPost: function (deleteBulkVaultsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteBulkVaultsRequest_1], args_1, true), void 0, function (deleteBulkVaultsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/DeleteBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteBulkVaultsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DetachBulkVaultsRequest} [detachBulkVaultsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsDetachBulkPost: function (detachBulkVaultsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([detachBulkVaultsRequest_1], args_1, true), void 0, function (detachBulkVaultsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/DetachBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(detachBulkVaultsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [groupId]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {Ownership} [ownership]
         * @param {VaultSecureNotesOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsGet: function (page_1, pageLength_1, groupId_1, employeeAccountId_1, searchQuery_1, ownership_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, groupId_1, employeeAccountId_1, searchQuery_1, ownership_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultCreditCardsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultCreditCardsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/Vaults/GetVaultCreditCards";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            if (employeeAccountId !== undefined) {
                                localVarQueryParameter['EmployeeAccountId'] = employeeAccountId;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (ownership !== undefined) {
                                localVarQueryParameter['Ownership'] = ownership;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordByIdVaultIdGet: function (vaultId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([vaultId_1], args_1, true), void 0, function (vaultId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'vaultId' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultPasswordByIdVaultIdGet', 'vaultId', vaultId);
                            localVarPath = "/api/v1/Vaults/GetVaultPasswordById/{vaultId}"
                                .replace("{".concat("vaultId", "}"), encodeURIComponent(String(vaultId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [groupId]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {Ownership} [ownership]
         * @param {string} [applicationName]
         * @param {number} [minStrength]
         * @param {number} [maxStrength]
         * @param {VaultOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsGet: function (page_1, pageLength_1, groupId_1, employeeAccountId_1, searchQuery_1, ownership_1, applicationName_1, minStrength_1, maxStrength_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 11; _i < arguments.length; _i++) {
                args_1[_i - 11] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, groupId_1, employeeAccountId_1, searchQuery_1, ownership_1, applicationName_1, minStrength_1, maxStrength_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, applicationName, minStrength, maxStrength, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultPasswordsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultPasswordsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/Vaults/GetVaultPasswords";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            if (employeeAccountId !== undefined) {
                                localVarQueryParameter['EmployeeAccountId'] = employeeAccountId;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (ownership !== undefined) {
                                localVarQueryParameter['Ownership'] = ownership;
                            }
                            if (applicationName !== undefined) {
                                localVarQueryParameter['ApplicationName'] = applicationName;
                            }
                            if (minStrength !== undefined) {
                                localVarQueryParameter['MinStrength'] = minStrength;
                            }
                            if (maxStrength !== undefined) {
                                localVarQueryParameter['MaxStrength'] = maxStrength;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [groupId]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {Ownership} [ownership]
         * @param {VaultSecureNotesOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesGet: function (page_1, pageLength_1, groupId_1, employeeAccountId_1, searchQuery_1, ownership_1, orderPropertyName_1, isDescending_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1, groupId_1, employeeAccountId_1, searchQuery_1, ownership_1, orderPropertyName_1, isDescending_1], args_1, true), void 0, function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultSecureNotesGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VaultsGetVaultSecureNotesGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/Vaults/GetVaultSecureNotes";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['GroupId'] = groupId;
                            }
                            if (employeeAccountId !== undefined) {
                                localVarQueryParameter['EmployeeAccountId'] = employeeAccountId;
                            }
                            if (searchQuery !== undefined) {
                                localVarQueryParameter['SearchQuery'] = searchQuery;
                            }
                            if (ownership !== undefined) {
                                localVarQueryParameter['Ownership'] = ownership;
                            }
                            if (orderPropertyName !== undefined) {
                                localVarQueryParameter['OrderPropertyName'] = orderPropertyName;
                            }
                            if (isDescending !== undefined) {
                                localVarQueryParameter['IsDescending'] = isDescending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {MoveToPrivateKeychainBulkRequest} [moveToPrivateKeychainBulkRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveToPrivateKeychainBulkPost: function (moveToPrivateKeychainBulkRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([moveToPrivateKeychainBulkRequest_1], args_1, true), void 0, function (moveToPrivateKeychainBulkRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/Vaults/MoveToPrivateKeychainBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(moveToPrivateKeychainBulkRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.VaultsApiAxiosParamCreator = VaultsApiAxiosParamCreator;
/**
 * VaultsApi - functional programming interface
 * @export
 */
var VaultsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VaultsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {CreateVaultCreditCardRequest} [createVaultCreditCardRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsCreateVaultCreditCardPost: function (createVaultCreditCardRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsCreateVaultCreditCardPost(createVaultCreditCardRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultPasswordRequest} [createVaultPasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsCreateVaultPasswordPost: function (createVaultPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsCreateVaultPasswordPost(createVaultPasswordRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultSecureNoteRequest} [createVaultSecureNoteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsCreateVaultSecureNotePost: function (createVaultSecureNoteRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsCreateVaultSecureNotePost(createVaultSecureNoteRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkVaultsRequest} [deleteBulkVaultsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsDeleteBulkPost: function (deleteBulkVaultsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsDeleteBulkPost(deleteBulkVaultsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DetachBulkVaultsRequest} [detachBulkVaultsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsDetachBulkPost: function (detachBulkVaultsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsDetachBulkPost(detachBulkVaultsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [groupId]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {Ownership} [ownership]
         * @param {VaultSecureNotesOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsGet: function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultCreditCardsGet(page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordByIdVaultIdGet: function (vaultId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultPasswordByIdVaultIdGet(vaultId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [groupId]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {Ownership} [ownership]
         * @param {string} [applicationName]
         * @param {number} [minStrength]
         * @param {number} [maxStrength]
         * @param {VaultOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsGet: function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, applicationName, minStrength, maxStrength, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultPasswordsGet(page, pageLength, groupId, employeeAccountId, searchQuery, ownership, applicationName, minStrength, maxStrength, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [groupId]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {Ownership} [ownership]
         * @param {VaultSecureNotesOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesGet: function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsGetVaultSecureNotesGet(page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {MoveToPrivateKeychainBulkRequest} [moveToPrivateKeychainBulkRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveToPrivateKeychainBulkPost: function (moveToPrivateKeychainBulkRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsMoveToPrivateKeychainBulkPost(moveToPrivateKeychainBulkRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VaultsApiFp = VaultsApiFp;
/**
 * VaultsApi - factory interface
 * @export
 */
var VaultsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VaultsApiFp)(configuration);
    return {
        /**
         *
         * @param {CreateVaultCreditCardRequest} [createVaultCreditCardRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsCreateVaultCreditCardPost: function (createVaultCreditCardRequest, options) {
            return localVarFp.apiV1VaultsCreateVaultCreditCardPost(createVaultCreditCardRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultPasswordRequest} [createVaultPasswordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsCreateVaultPasswordPost: function (createVaultPasswordRequest, options) {
            return localVarFp.apiV1VaultsCreateVaultPasswordPost(createVaultPasswordRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultSecureNoteRequest} [createVaultSecureNoteRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsCreateVaultSecureNotePost: function (createVaultSecureNoteRequest, options) {
            return localVarFp.apiV1VaultsCreateVaultSecureNotePost(createVaultSecureNoteRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeleteBulkVaultsRequest} [deleteBulkVaultsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsDeleteBulkPost: function (deleteBulkVaultsRequest, options) {
            return localVarFp.apiV1VaultsDeleteBulkPost(deleteBulkVaultsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DetachBulkVaultsRequest} [detachBulkVaultsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsDetachBulkPost: function (detachBulkVaultsRequest, options) {
            return localVarFp.apiV1VaultsDetachBulkPost(detachBulkVaultsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [groupId]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {Ownership} [ownership]
         * @param {VaultSecureNotesOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultCreditCardsGet: function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1VaultsGetVaultCreditCardsGet(page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} vaultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordByIdVaultIdGet: function (vaultId, options) {
            return localVarFp.apiV1VaultsGetVaultPasswordByIdVaultIdGet(vaultId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [groupId]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {Ownership} [ownership]
         * @param {string} [applicationName]
         * @param {number} [minStrength]
         * @param {number} [maxStrength]
         * @param {VaultOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultPasswordsGet: function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, applicationName, minStrength, maxStrength, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1VaultsGetVaultPasswordsGet(page, pageLength, groupId, employeeAccountId, searchQuery, ownership, applicationName, minStrength, maxStrength, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {string} [groupId]
         * @param {string} [employeeAccountId]
         * @param {string} [searchQuery]
         * @param {Ownership} [ownership]
         * @param {VaultSecureNotesOrderProperty} [orderPropertyName]
         * @param {boolean} [isDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsGetVaultSecureNotesGet: function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options) {
            return localVarFp.apiV1VaultsGetVaultSecureNotesGet(page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {MoveToPrivateKeychainBulkRequest} [moveToPrivateKeychainBulkRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsMoveToPrivateKeychainBulkPost: function (moveToPrivateKeychainBulkRequest, options) {
            return localVarFp.apiV1VaultsMoveToPrivateKeychainBulkPost(moveToPrivateKeychainBulkRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VaultsApiFactory = VaultsApiFactory;
/**
 * VaultsApi - object-oriented interface
 * @export
 * @class VaultsApi
 * @extends {BaseAPI}
 */
var VaultsApi = /** @class */ (function (_super) {
    __extends(VaultsApi, _super);
    function VaultsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {CreateVaultCreditCardRequest} [createVaultCreditCardRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsCreateVaultCreditCardPost = function (createVaultCreditCardRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsCreateVaultCreditCardPost(createVaultCreditCardRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultPasswordRequest} [createVaultPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsCreateVaultPasswordPost = function (createVaultPasswordRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsCreateVaultPasswordPost(createVaultPasswordRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultSecureNoteRequest} [createVaultSecureNoteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsCreateVaultSecureNotePost = function (createVaultSecureNoteRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsCreateVaultSecureNotePost(createVaultSecureNoteRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeleteBulkVaultsRequest} [deleteBulkVaultsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsDeleteBulkPost = function (deleteBulkVaultsRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsDeleteBulkPost(deleteBulkVaultsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DetachBulkVaultsRequest} [detachBulkVaultsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsDetachBulkPost = function (detachBulkVaultsRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsDetachBulkPost(detachBulkVaultsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} [groupId]
     * @param {string} [employeeAccountId]
     * @param {string} [searchQuery]
     * @param {Ownership} [ownership]
     * @param {VaultSecureNotesOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultCreditCardsGet = function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultCreditCardsGet(page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} vaultId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultPasswordByIdVaultIdGet = function (vaultId, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultPasswordByIdVaultIdGet(vaultId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} [groupId]
     * @param {string} [employeeAccountId]
     * @param {string} [searchQuery]
     * @param {Ownership} [ownership]
     * @param {string} [applicationName]
     * @param {number} [minStrength]
     * @param {number} [maxStrength]
     * @param {VaultOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultPasswordsGet = function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, applicationName, minStrength, maxStrength, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultPasswordsGet(page, pageLength, groupId, employeeAccountId, searchQuery, ownership, applicationName, minStrength, maxStrength, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {string} [groupId]
     * @param {string} [employeeAccountId]
     * @param {string} [searchQuery]
     * @param {Ownership} [ownership]
     * @param {VaultSecureNotesOrderProperty} [orderPropertyName]
     * @param {boolean} [isDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsGetVaultSecureNotesGet = function (page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsGetVaultSecureNotesGet(page, pageLength, groupId, employeeAccountId, searchQuery, ownership, orderPropertyName, isDescending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {MoveToPrivateKeychainBulkRequest} [moveToPrivateKeychainBulkRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsApi
     */
    VaultsApi.prototype.apiV1VaultsMoveToPrivateKeychainBulkPost = function (moveToPrivateKeychainBulkRequest, options) {
        var _this = this;
        return (0, exports.VaultsApiFp)(this.configuration).apiV1VaultsMoveToPrivateKeychainBulkPost(moveToPrivateKeychainBulkRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VaultsApi;
}(base_1.BaseAPI));
exports.VaultsApi = VaultsApi;
/**
 * VaultsToEmployeeAccountsApi - axios parameter creator
 * @export
 */
var VaultsToEmployeeAccountsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {AddVaultsToEmployeeAccountsRequest} [addVaultsToEmployeeAccountsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsAddPost: function (addVaultsToEmployeeAccountsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([addVaultsToEmployeeAccountsRequest_1], args_1, true), void 0, function (addVaultsToEmployeeAccountsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts/Add";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addVaultsToEmployeeAccountsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultCreditCardForEmployeeRequest} [createVaultCreditCardForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost: function (createVaultCreditCardForEmployeeRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultCreditCardForEmployeeRequest_1], args_1, true), void 0, function (createVaultCreditCardForEmployeeRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts/CreateVaultCreditCard";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultCreditCardForEmployeeRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultPasswordForEmployeeAccountRequest} [createVaultPasswordForEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost: function (createVaultPasswordForEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultPasswordForEmployeeAccountRequest_1], args_1, true), void 0, function (createVaultPasswordForEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts/CreateVaultPassword";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultPasswordForEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForEmployeeAccountRequest} [createVaultSecureNoteForEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost: function (createVaultSecureNoteForEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultSecureNoteForEmployeeAccountRequest_1], args_1, true), void 0, function (createVaultSecureNoteForEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts/CreateVaultSecureNote";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultSecureNoteForEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkVaultToEmployeeAccountRequest} [deleteBulkVaultToEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsDeleteBulkPost: function (deleteBulkVaultToEmployeeAccountRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteBulkVaultToEmployeeAccountRequest_1], args_1, true), void 0, function (deleteBulkVaultToEmployeeAccountRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToEmployeeAccounts/DeleteBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteBulkVaultToEmployeeAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.VaultsToEmployeeAccountsApiAxiosParamCreator = VaultsToEmployeeAccountsApiAxiosParamCreator;
/**
 * VaultsToEmployeeAccountsApi - functional programming interface
 * @export
 */
var VaultsToEmployeeAccountsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VaultsToEmployeeAccountsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AddVaultsToEmployeeAccountsRequest} [addVaultsToEmployeeAccountsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsAddPost: function (addVaultsToEmployeeAccountsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsAddPost(addVaultsToEmployeeAccountsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultCreditCardForEmployeeRequest} [createVaultCreditCardForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost: function (createVaultCreditCardForEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost(createVaultCreditCardForEmployeeRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultPasswordForEmployeeAccountRequest} [createVaultPasswordForEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost: function (createVaultPasswordForEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost(createVaultPasswordForEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForEmployeeAccountRequest} [createVaultSecureNoteForEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost: function (createVaultSecureNoteForEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost(createVaultSecureNoteForEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkVaultToEmployeeAccountRequest} [deleteBulkVaultToEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsDeleteBulkPost: function (deleteBulkVaultToEmployeeAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToEmployeeAccountsDeleteBulkPost(deleteBulkVaultToEmployeeAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VaultsToEmployeeAccountsApiFp = VaultsToEmployeeAccountsApiFp;
/**
 * VaultsToEmployeeAccountsApi - factory interface
 * @export
 */
var VaultsToEmployeeAccountsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VaultsToEmployeeAccountsApiFp)(configuration);
    return {
        /**
         *
         * @param {AddVaultsToEmployeeAccountsRequest} [addVaultsToEmployeeAccountsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsAddPost: function (addVaultsToEmployeeAccountsRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsAddPost(addVaultsToEmployeeAccountsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultCreditCardForEmployeeRequest} [createVaultCreditCardForEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost: function (createVaultCreditCardForEmployeeRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost(createVaultCreditCardForEmployeeRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultPasswordForEmployeeAccountRequest} [createVaultPasswordForEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost: function (createVaultPasswordForEmployeeAccountRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost(createVaultPasswordForEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForEmployeeAccountRequest} [createVaultSecureNoteForEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost: function (createVaultSecureNoteForEmployeeAccountRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost(createVaultSecureNoteForEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeleteBulkVaultToEmployeeAccountRequest} [deleteBulkVaultToEmployeeAccountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToEmployeeAccountsDeleteBulkPost: function (deleteBulkVaultToEmployeeAccountRequest, options) {
            return localVarFp.apiV1VaultsToEmployeeAccountsDeleteBulkPost(deleteBulkVaultToEmployeeAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VaultsToEmployeeAccountsApiFactory = VaultsToEmployeeAccountsApiFactory;
/**
 * VaultsToEmployeeAccountsApi - object-oriented interface
 * @export
 * @class VaultsToEmployeeAccountsApi
 * @extends {BaseAPI}
 */
var VaultsToEmployeeAccountsApi = /** @class */ (function (_super) {
    __extends(VaultsToEmployeeAccountsApi, _super);
    function VaultsToEmployeeAccountsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {AddVaultsToEmployeeAccountsRequest} [addVaultsToEmployeeAccountsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsAddPost = function (addVaultsToEmployeeAccountsRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsAddPost(addVaultsToEmployeeAccountsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultCreditCardForEmployeeRequest} [createVaultCreditCardForEmployeeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost = function (createVaultCreditCardForEmployeeRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsCreateVaultCreditCardPost(createVaultCreditCardForEmployeeRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultPasswordForEmployeeAccountRequest} [createVaultPasswordForEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost = function (createVaultPasswordForEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsCreateVaultPasswordPost(createVaultPasswordForEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultSecureNoteForEmployeeAccountRequest} [createVaultSecureNoteForEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost = function (createVaultSecureNoteForEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsCreateVaultSecureNotePost(createVaultSecureNoteForEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeleteBulkVaultToEmployeeAccountRequest} [deleteBulkVaultToEmployeeAccountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToEmployeeAccountsApi
     */
    VaultsToEmployeeAccountsApi.prototype.apiV1VaultsToEmployeeAccountsDeleteBulkPost = function (deleteBulkVaultToEmployeeAccountRequest, options) {
        var _this = this;
        return (0, exports.VaultsToEmployeeAccountsApiFp)(this.configuration).apiV1VaultsToEmployeeAccountsDeleteBulkPost(deleteBulkVaultToEmployeeAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VaultsToEmployeeAccountsApi;
}(base_1.BaseAPI));
exports.VaultsToEmployeeAccountsApi = VaultsToEmployeeAccountsApi;
/**
 * VaultsToGroupsApi - axios parameter creator
 * @export
 */
var VaultsToGroupsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {AddVaultsToGroupsRequest} [addVaultsToGroupsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsAddPost: function (addVaultsToGroupsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([addVaultsToGroupsRequest_1], args_1, true), void 0, function (addVaultsToGroupsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToGroups/Add";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addVaultsToGroupsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultCreditCardForGroupRequest} [createVaultCreditCardForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultCreditCardPost: function (createVaultCreditCardForGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultCreditCardForGroupRequest_1], args_1, true), void 0, function (createVaultCreditCardForGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToGroups/CreateVaultCreditCard";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultCreditCardForGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultForGroupRequest} [createVaultForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultPasswordPost: function (createVaultForGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultForGroupRequest_1], args_1, true), void 0, function (createVaultForGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToGroups/CreateVaultPassword";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultForGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForGroupRequest} [createVaultSecureNoteForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultSecureNotePost: function (createVaultSecureNoteForGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createVaultSecureNoteForGroupRequest_1], args_1, true), void 0, function (createVaultSecureNoteForGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToGroups/CreateVaultSecureNote";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createVaultSecureNoteForGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkVaultToGroupRequest} [deleteBulkVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsDeleteBulkPost: function (deleteBulkVaultToGroupRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteBulkVaultToGroupRequest_1], args_1, true), void 0, function (deleteBulkVaultToGroupRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VaultsToGroups/DeleteBulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteBulkVaultToGroupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.VaultsToGroupsApiAxiosParamCreator = VaultsToGroupsApiAxiosParamCreator;
/**
 * VaultsToGroupsApi - functional programming interface
 * @export
 */
var VaultsToGroupsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VaultsToGroupsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AddVaultsToGroupsRequest} [addVaultsToGroupsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsAddPost: function (addVaultsToGroupsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToGroupsAddPost(addVaultsToGroupsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultCreditCardForGroupRequest} [createVaultCreditCardForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultCreditCardPost: function (createVaultCreditCardForGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToGroupsCreateVaultCreditCardPost(createVaultCreditCardForGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultForGroupRequest} [createVaultForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultPasswordPost: function (createVaultForGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToGroupsCreateVaultPasswordPost(createVaultForGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForGroupRequest} [createVaultSecureNoteForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultSecureNotePost: function (createVaultSecureNoteForGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToGroupsCreateVaultSecureNotePost(createVaultSecureNoteForGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {DeleteBulkVaultToGroupRequest} [deleteBulkVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsDeleteBulkPost: function (deleteBulkVaultToGroupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VaultsToGroupsDeleteBulkPost(deleteBulkVaultToGroupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VaultsToGroupsApiFp = VaultsToGroupsApiFp;
/**
 * VaultsToGroupsApi - factory interface
 * @export
 */
var VaultsToGroupsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VaultsToGroupsApiFp)(configuration);
    return {
        /**
         *
         * @param {AddVaultsToGroupsRequest} [addVaultsToGroupsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsAddPost: function (addVaultsToGroupsRequest, options) {
            return localVarFp.apiV1VaultsToGroupsAddPost(addVaultsToGroupsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultCreditCardForGroupRequest} [createVaultCreditCardForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultCreditCardPost: function (createVaultCreditCardForGroupRequest, options) {
            return localVarFp.apiV1VaultsToGroupsCreateVaultCreditCardPost(createVaultCreditCardForGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultForGroupRequest} [createVaultForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultPasswordPost: function (createVaultForGroupRequest, options) {
            return localVarFp.apiV1VaultsToGroupsCreateVaultPasswordPost(createVaultForGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreateVaultSecureNoteForGroupRequest} [createVaultSecureNoteForGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsCreateVaultSecureNotePost: function (createVaultSecureNoteForGroupRequest, options) {
            return localVarFp.apiV1VaultsToGroupsCreateVaultSecureNotePost(createVaultSecureNoteForGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DeleteBulkVaultToGroupRequest} [deleteBulkVaultToGroupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VaultsToGroupsDeleteBulkPost: function (deleteBulkVaultToGroupRequest, options) {
            return localVarFp.apiV1VaultsToGroupsDeleteBulkPost(deleteBulkVaultToGroupRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VaultsToGroupsApiFactory = VaultsToGroupsApiFactory;
/**
 * VaultsToGroupsApi - object-oriented interface
 * @export
 * @class VaultsToGroupsApi
 * @extends {BaseAPI}
 */
var VaultsToGroupsApi = /** @class */ (function (_super) {
    __extends(VaultsToGroupsApi, _super);
    function VaultsToGroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {AddVaultsToGroupsRequest} [addVaultsToGroupsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToGroupsApi
     */
    VaultsToGroupsApi.prototype.apiV1VaultsToGroupsAddPost = function (addVaultsToGroupsRequest, options) {
        var _this = this;
        return (0, exports.VaultsToGroupsApiFp)(this.configuration).apiV1VaultsToGroupsAddPost(addVaultsToGroupsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultCreditCardForGroupRequest} [createVaultCreditCardForGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToGroupsApi
     */
    VaultsToGroupsApi.prototype.apiV1VaultsToGroupsCreateVaultCreditCardPost = function (createVaultCreditCardForGroupRequest, options) {
        var _this = this;
        return (0, exports.VaultsToGroupsApiFp)(this.configuration).apiV1VaultsToGroupsCreateVaultCreditCardPost(createVaultCreditCardForGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultForGroupRequest} [createVaultForGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToGroupsApi
     */
    VaultsToGroupsApi.prototype.apiV1VaultsToGroupsCreateVaultPasswordPost = function (createVaultForGroupRequest, options) {
        var _this = this;
        return (0, exports.VaultsToGroupsApiFp)(this.configuration).apiV1VaultsToGroupsCreateVaultPasswordPost(createVaultForGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreateVaultSecureNoteForGroupRequest} [createVaultSecureNoteForGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToGroupsApi
     */
    VaultsToGroupsApi.prototype.apiV1VaultsToGroupsCreateVaultSecureNotePost = function (createVaultSecureNoteForGroupRequest, options) {
        var _this = this;
        return (0, exports.VaultsToGroupsApiFp)(this.configuration).apiV1VaultsToGroupsCreateVaultSecureNotePost(createVaultSecureNoteForGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DeleteBulkVaultToGroupRequest} [deleteBulkVaultToGroupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultsToGroupsApi
     */
    VaultsToGroupsApi.prototype.apiV1VaultsToGroupsDeleteBulkPost = function (deleteBulkVaultToGroupRequest, options) {
        var _this = this;
        return (0, exports.VaultsToGroupsApiFp)(this.configuration).apiV1VaultsToGroupsDeleteBulkPost(deleteBulkVaultToGroupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VaultsToGroupsApi;
}(base_1.BaseAPI));
exports.VaultsToGroupsApi = VaultsToGroupsApi;
/**
 * VerifiedDomainsApi - axios parameter creator
 * @export
 */
var VerifiedDomainsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {DeleteBulkVerifiedDomainsRequest} [deleteBulkVerifiedDomainsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VerifiedDomainsDelete: function (deleteBulkVerifiedDomainsRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([deleteBulkVerifiedDomainsRequest_1], args_1, true), void 0, function (deleteBulkVerifiedDomainsRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VerifiedDomains";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteBulkVerifiedDomainsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VerifiedDomainsGet: function (page_1, pageLength_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, pageLength_1], args_1, true), void 0, function (page, pageLength, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VerifiedDomainsGet', 'page', page);
                            // verify required parameter 'pageLength' is not null or undefined
                            (0, common_1.assertParamExists)('apiV1VerifiedDomainsGet', 'pageLength', pageLength);
                            localVarPath = "/api/v1/VerifiedDomains";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['Page'] = page;
                            }
                            if (pageLength !== undefined) {
                                localVarQueryParameter['PageLength'] = pageLength;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {AddVerifiedDomainRequest} [addVerifiedDomainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VerifiedDomainsPost: function (addVerifiedDomainRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([addVerifiedDomainRequest_1], args_1, true), void 0, function (addVerifiedDomainRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/v1/VerifiedDomains";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication jwt_auth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication jwt_auth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addVerifiedDomainRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.VerifiedDomainsApiAxiosParamCreator = VerifiedDomainsApiAxiosParamCreator;
/**
 * VerifiedDomainsApi - functional programming interface
 * @export
 */
var VerifiedDomainsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VerifiedDomainsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {DeleteBulkVerifiedDomainsRequest} [deleteBulkVerifiedDomainsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VerifiedDomainsDelete: function (deleteBulkVerifiedDomainsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VerifiedDomainsDelete(deleteBulkVerifiedDomainsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VerifiedDomainsGet: function (page, pageLength, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VerifiedDomainsGet(page, pageLength, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {AddVerifiedDomainRequest} [addVerifiedDomainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VerifiedDomainsPost: function (addVerifiedDomainRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiV1VerifiedDomainsPost(addVerifiedDomainRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VerifiedDomainsApiFp = VerifiedDomainsApiFp;
/**
 * VerifiedDomainsApi - factory interface
 * @export
 */
var VerifiedDomainsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VerifiedDomainsApiFp)(configuration);
    return {
        /**
         *
         * @param {DeleteBulkVerifiedDomainsRequest} [deleteBulkVerifiedDomainsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VerifiedDomainsDelete: function (deleteBulkVerifiedDomainsRequest, options) {
            return localVarFp.apiV1VerifiedDomainsDelete(deleteBulkVerifiedDomainsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} page
         * @param {number} pageLength
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VerifiedDomainsGet: function (page, pageLength, options) {
            return localVarFp.apiV1VerifiedDomainsGet(page, pageLength, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {AddVerifiedDomainRequest} [addVerifiedDomainRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1VerifiedDomainsPost: function (addVerifiedDomainRequest, options) {
            return localVarFp.apiV1VerifiedDomainsPost(addVerifiedDomainRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VerifiedDomainsApiFactory = VerifiedDomainsApiFactory;
/**
 * VerifiedDomainsApi - object-oriented interface
 * @export
 * @class VerifiedDomainsApi
 * @extends {BaseAPI}
 */
var VerifiedDomainsApi = /** @class */ (function (_super) {
    __extends(VerifiedDomainsApi, _super);
    function VerifiedDomainsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {DeleteBulkVerifiedDomainsRequest} [deleteBulkVerifiedDomainsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifiedDomainsApi
     */
    VerifiedDomainsApi.prototype.apiV1VerifiedDomainsDelete = function (deleteBulkVerifiedDomainsRequest, options) {
        var _this = this;
        return (0, exports.VerifiedDomainsApiFp)(this.configuration).apiV1VerifiedDomainsDelete(deleteBulkVerifiedDomainsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} page
     * @param {number} pageLength
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifiedDomainsApi
     */
    VerifiedDomainsApi.prototype.apiV1VerifiedDomainsGet = function (page, pageLength, options) {
        var _this = this;
        return (0, exports.VerifiedDomainsApiFp)(this.configuration).apiV1VerifiedDomainsGet(page, pageLength, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {AddVerifiedDomainRequest} [addVerifiedDomainRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifiedDomainsApi
     */
    VerifiedDomainsApi.prototype.apiV1VerifiedDomainsPost = function (addVerifiedDomainRequest, options) {
        var _this = this;
        return (0, exports.VerifiedDomainsApiFp)(this.configuration).apiV1VerifiedDomainsPost(addVerifiedDomainRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VerifiedDomainsApi;
}(base_1.BaseAPI));
exports.VerifiedDomainsApi = VerifiedDomainsApi;
